import React, { useState, useCallback } from "react";
import { 
  SuccessMessage,
  FailMessage,
  Loading,
  FormatValueToDecimal,
  CompanySelect,
  FormatDateToMDY,
  DateSelect,
  FormatDateToWord,
  VendorSelect,
  TermsSelect,
  ItemsSelect,
  PurchaseInvoiceOptionalVendorSelect
} from "../../common/APICommon";
import { apiUrl } from "../../utils/Configuration";
import axios from 'axios';
import ExcelJS from 'exceljs';
import { PDFDocument } from "pdf-lib";
import fontkit from "@pdf-lib/fontkit";
import NoAccess from "../NoAccess";
import HistoryEduIcon from '@mui/icons-material/HistoryEdu';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import PersonSearchIcon from '@mui/icons-material/PersonSearch';
import SearchIcon from '@mui/icons-material/Search';

export default function PurchaseOrderReport() {
//#region Others
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [failMessage, setFailMessage] = useState("");
//#endregion






//#region Variables 
  const [company, setCompany] = useState(null);
  // const today = new Date().toISOString().split("T")[0];
  const [dateFrom, setDateFrom] = useState(null);
  const [dateTo, setDateTo] = useState(null);
  const [terms, setTerms] = useState("");
  const [invoice, setInvoice] = useState(null);

  const [vendor, setVendor] = useState(null);
  const [showVendorSelect, setShowVendorSelect] = useState(false);

  const openVendorSelect = () => {
    setShowVendorSelect(true)
  }
  const closeVendorSelect = () => {
    setShowVendorSelect(false)
  }

  const [item, setItem] = useState(null);
  const [showItemSelect, setShowItemSelect] = useState(false);

  const openItemSelect = () => {
    setShowItemSelect(true)
  }
  const closeItemSelect = () => {
    setShowItemSelect(false)
  }
//#endregion






//#region Generate
  const fetchReportData = useCallback(async () => {
    const body = {
      dateFrom: dateFrom,
      dateTo: dateTo,
      vendorId: vendor ? vendor?.vendorId : null,
      itemCode: item ? item.itemCode : null,
      terms: terms ? terms : null,
      documentId: invoice ? invoice?.id : null,
    }

    try {
      // const response = await axios.post(`${apiUrl}/api/Report/report-data/statement-of-account`, body, {
      const response = await axios.post(`${apiUrl}/api/Report/report-data/purchase-order`, body, {
        headers: { 'Content-Type': 'application/json'}
      })
        
      return (response.data)
    } catch (error) {
      console.error('Error fetching data:', error);
      return null
    }
  }, [dateFrom, dateTo, vendor, item, terms, invoice]);

  // PDF
  const generatePurchaseOrderByVendorDetailedHandleClick = async () => {
    if (!dateFrom || !dateTo || !company) {
      setFailMessage("Please fill up Date From, Date To, Company fields");
      return;
    }

    setLoading(true);
    const allData = await fetchReportData();
    const _data = allData?.byVendorDetailed;

    if (!_data || _data?.length <= 0) {
      setFailMessage("No record found");
      setLoading(false);
      return;
    }

    try {
      const pdfUrl = `${window.location.origin}/docs/PURCHASE_ORDER_BY_VENDOR_DETAILED.pdf`;
      const templateBytes = await fetch(pdfUrl).then((r) => r.arrayBuffer());
      const templateDoc = await PDFDocument.load(templateBytes);
      
      const response = await fetch(pdfUrl);
      const pdfBytes = await response.arrayBuffer();
      const pdfDoc = await PDFDocument.load(pdfBytes);

      pdfDoc.registerFontkit(fontkit);
      const fontResponse = await fetch("/calibri.ttf");
      const fontBytes = await fontResponse.arrayBuffer();
      const calibriFont = await pdfDoc.embedFont(fontBytes);

      const boldResponse = await fetch("/calibrib.ttf");
      const boldBytes = await boldResponse.arrayBuffer();
      const calibriBold = await pdfDoc.embedFont(boldBytes);

      const wrapText = (text, maxWidth, font, fontSize) => {
        if (!text) return [""];
        const words = text.split(" ");
        const lines = [];
        let currentLine = "";
        for (const word of words) {
          const testLine = currentLine ? `${currentLine} ${word}` : word;
          if (font.widthOfTextAtSize(testLine, fontSize) <= maxWidth) {
            currentLine = testLine;
          } else {
            if (currentLine) lines.push(currentLine);
            currentLine = word;
          }
        }
        if (currentLine) lines.push(currentLine);
        return lines;
      };

      const drawHeader = (targetPage) => {
        targetPage.drawText(company.name?.toString() ?? "", { x: 35, y: 583, size: 16, font: calibriBold });
        targetPage.drawText(company.address?.toString() ?? "", { x: 35, y: 573, size: 8, font: calibriFont });
        targetPage.drawText(company.tin?.toString() ?? "", { x: 35, y: 563, size: 8, font: calibriFont });

        targetPage.drawText(vendor?.vendorName1?.toString() ?? "", { x: 74, y: 526, size: 8, font: calibriFont });
        targetPage.drawText(`${FormatDateToWord(dateFrom)} to ${FormatDateToWord(dateTo)}`, { x: 83, y: 515, size: 8, font: calibriFont });
        targetPage.drawText(`${item?.itemCode?.toString() ?? ""} ${item?.itemDescription?.toString() ?? ""}`, { x: 57, y: 506, size: 8, font: calibriFont });
        targetPage.drawText(FormatDateToWord(new Date()), { x: 82, y: 495, size: 8, font: calibriFont });
      };

      let pages = pdfDoc.getPages();
      let currentPage = pages[0];
      drawHeader(currentPage);

      let yPosition = 446;
      const bottomThreshold = 80;
      const colWidthDesc = 180;
      const lineHeight = 12;
      let grandAmount = 0;

      // Helper to handle page breaks
      const addNewPage = async () => {
        const [templatePage] = await pdfDoc.copyPages(templateDoc, [0]);
        currentPage = pdfDoc.addPage(templatePage);
        drawHeader(currentPage);
        yPosition = 446;
      };

      for (const record of _data) {
        // Check space for Vendor Name Header
        if (yPosition < bottomThreshold + 20) await addNewPage();

        currentPage.drawText(`${record.vendorName ?? ""}`, { x: 35, y: yPosition, size: 8, font: calibriBold });
        yPosition -= 15;

        for (const order of record.orders) {
          for (const itemRow of order.items) {
            const descLines = wrapText(itemRow.itemDescription, colWidthDesc, calibriFont, 8);
            const rowHeight = Math.max(lineHeight, descLines.length * lineHeight);

            // --- PAGE BREAK CHECK FOR ITEM ROW ---
            if (yPosition - rowHeight < bottomThreshold) {
              await addNewPage();
            }

            // Draw Row Data
            currentPage.drawText(FormatDateToMDY(order.date), { x: 35, y: yPosition, size: 8, font: calibriFont });
            currentPage.drawText(`${order?.referenceNumber ?? ""}`, { x: 101, y: yPosition, size: 8, font: calibriFont });

            // Draw wrapped description
            for (let i = 0; i < descLines.length; i++) {
              currentPage.drawText(descLines[i], {
                x: 250,
                y: yPosition - i * lineHeight,
                size: 8,
                font: calibriFont,
              });
            }

            const qtyVal = parseFloat(itemRow.quantity) || 0;
            currentPage.drawText(`${FormatValueToDecimal(qtyVal)}`, { x: 398, y: yPosition, size: 8, font: calibriFont });
            currentPage.drawText(`${itemRow.uomName ?? ""}`, { x: 435, y: yPosition, size: 8, font: calibriFont });
            currentPage.drawText(`${FormatValueToDecimal(itemRow.unitPrice)} %`, { x: 475, y: yPosition, size: 8, font: calibriFont });
            currentPage.drawText(`${FormatValueToDecimal(itemRow.discountPercent)} %`, { x: 535, y: yPosition, size: 8, font: calibriFont });
            currentPage.drawText(`${FormatValueToDecimal(itemRow.totalDiscount)}`, { x: 580, y: yPosition, size: 8, font: calibriFont });
            currentPage.drawText(`${FormatValueToDecimal(itemRow.netPrice)}`, { x: 634, y: yPosition, size: 8, font: calibriFont });
            currentPage.drawText(`${FormatValueToDecimal(itemRow.totalAmount)}`, { x: 696, y: yPosition, size: 8, font: calibriFont });

            yPosition -= rowHeight + 5;
            grandAmount += itemRow.totalAmount || 0;
          }
        }

        // We check if there's enough space for the line (5px) and the text (15px)
        if (yPosition < bottomThreshold + 30) {
          await addNewPage();
        }

        currentPage.drawLine({ start: { x: 35, y: yPosition }, end: { x: 757, y: yPosition }, thickness: 0.5 });
        yPosition -= 15;
        currentPage.drawText(`Supplier Sub-Total:  `, { x: 35, y: yPosition, size: 8, font: calibriBold });
        currentPage.drawText(`${FormatValueToDecimal(record.totalAmount)}`, { x: 696, y: yPosition, size: 8, font: calibriBold });
        
        yPosition -= 20; 
      }

      // --- FOOTER SECTION (GRAND TOTAL) ---
      if (yPosition < 100) {
        await addNewPage();
      }

      currentPage.drawLine({ start: { x: 35, y: yPosition }, end: { x: 757, y: yPosition }, thickness: 1 });
      yPosition -= 15;
      currentPage.drawText(`Grand Total:  `, { x: 35, y: yPosition, size: 9, font: calibriBold });
      currentPage.drawText(`${FormatValueToDecimal(grandAmount)}`, { x: 696, y: yPosition, size: 9, font: calibriBold });

      // --- PAGINATION ---
      const allPages = pdfDoc.getPages();
      const totalPages = allPages.length;
      allPages.forEach((page, index) => {
        page.drawText(`Page ${index + 1} of ${totalPages}`, {
          x: 680,
          y: 580,
          size: 10,
          font: calibriBold,
        });
      });

      const modifiedPdfBytes = await pdfDoc.save();
      const blob = new Blob([modifiedPdfBytes], { type: "application/pdf" });
      const a = document.createElement("a");
      a.href = URL.createObjectURL(blob);
      a.download = `PURCHASE_ORDER_BY_VENDOR_DETAILED.pdf`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);

    } catch (error) {
      console.error("Error:", error);
      setFailMessage("Error processing PDF");
    }
    setLoading(false);
  };

  const generatePurchaseOrderByVendorSummarizedHandleClick = async () => {
    if (!dateFrom || !dateTo || !company) {
      setFailMessage("Please fill up Date From, Date To, Company fields");
      return;
    }

    setLoading(true);
    const allData = await fetchReportData();
    const _data = allData?.byVendorDetailed;

    if (!_data || _data?.length <= 0) {
      setFailMessage("No record found");
      setLoading(false);
      return;
    }

    try {
      const pdfUrl = `${window.location.origin}/docs/PURCHASE_ORDER_BY_VENDOR_SUMMARIZED.pdf`;
      const templateBytes = await fetch(pdfUrl).then((r) => r.arrayBuffer());
      const templateDoc = await PDFDocument.load(templateBytes);
      
      const response = await fetch(pdfUrl);
      const pdfBytes = await response.arrayBuffer();
      const pdfDoc = await PDFDocument.load(pdfBytes);

      pdfDoc.registerFontkit(fontkit);
      const fontResponse = await fetch("/calibri.ttf");
      const fontBytes = await fontResponse.arrayBuffer();
      const calibriFont = await pdfDoc.embedFont(fontBytes);

      const boldResponse = await fetch("/calibrib.ttf");
      const boldBytes = await boldResponse.arrayBuffer();
      const calibriBold = await pdfDoc.embedFont(boldBytes);

      const drawHeader = (targetPage) => {
        targetPage.drawText(company.name?.toString() ?? "", { x: 35, y: 761, size: 16, font: calibriBold });
        targetPage.drawText(company.address?.toString() ?? "", { x: 35, y: 751, size: 8, font: calibriFont });
        targetPage.drawText(company.tin?.toString() ?? "", { x: 35, y: 741, size: 8, font: calibriFont });

        targetPage.drawText(vendor?.vendorName1?.toString() ?? "", { x: 70, y: 706, size: 8, font: calibriFont });
        targetPage.drawText(`${FormatDateToWord(dateFrom)} to ${FormatDateToWord(dateTo)}`, { x: 90, y: 695.5, size: 8, font: calibriFont });
        targetPage.drawText(`${item?.itemCode?.toString() ?? ""} ${item?.itemDescription?.toString() ?? ""}`, { x: 57, y: 685.5, size: 8, font: calibriFont });
        targetPage.drawText(FormatDateToWord(new Date()), { x: 82, y: 674.5, size: 8, font: calibriFont });
      };

      let pages = pdfDoc.getPages();
      let currentPage = pages[0];
      drawHeader(currentPage);

      let yPosition = 634;
      const bottomThreshold = 80;
      const lineHeight = 12;
      let grandAmount = 0;

      // Helper to handle page breaks
      const addNewPage = async () => {
        const [templatePage] = await pdfDoc.copyPages(templateDoc, [0]);
        currentPage = pdfDoc.addPage(templatePage);
        drawHeader(currentPage);
        yPosition = 634;
      };

      for (const record of _data) {
        // Check space for Vendor Name Header
        if (yPosition < bottomThreshold + 20) await addNewPage();

        currentPage.drawText(`${record.vendorName ?? ""}`, { x: 35, y: yPosition, size: 8, font: calibriBold });
        yPosition -= 15;

        for (const order of record.orders) {
          for (const itemRow of order.items) {
            // --- PAGE BREAK CHECK FOR ITEM ROW ---
            if (yPosition - lineHeight < bottomThreshold) {
              await addNewPage();
            }

            // Draw Row Data
            currentPage.drawText(FormatDateToMDY(order.date), { x: 35, y: yPosition, size: 8, font: calibriFont });
            currentPage.drawText(`${order?.referenceNumber ?? ""}`, { x: 157, y: yPosition, size: 8, font: calibriFont });
            currentPage.drawText(`${record?.terms ?? ""}`, { x: 380, y: yPosition, size: 8, font: calibriFont });

            currentPage.drawText(`${FormatValueToDecimal(itemRow.totalAmount)}`, { x: 495, y: yPosition, size: 8, font: calibriFont });

            yPosition -= lineHeight;
            grandAmount += itemRow.totalAmount || 0;
          }
        }

        // We check if there's enough space for the line (5px) and the text (15px)
        if (yPosition < bottomThreshold + 30) {
          await addNewPage();
        }

        currentPage.drawLine({ start: { x: 35, y: yPosition }, end: { x: 757, y: yPosition }, thickness: 0.5 });
        yPosition -= 15;
        currentPage.drawText(`Supplier Sub-Total:  `, { x: 35, y: yPosition, size: 8, font: calibriBold });
        currentPage.drawText(`${FormatValueToDecimal(record.totalAmount)}`, { x: 495, y: yPosition, size: 8, font: calibriBold });
        
        yPosition -= 20; 
      }

      // --- FOOTER SECTION (GRAND TOTAL) ---
      if (yPosition < 100) {
        await addNewPage();
      }

      currentPage.drawLine({ start: { x: 35, y: yPosition }, end: { x: 757, y: yPosition }, thickness: 1 });
      yPosition -= 15;
      currentPage.drawText(`Grand Total:  `, { x: 35, y: yPosition, size: 9, font: calibriBold });
      currentPage.drawText(`${FormatValueToDecimal(grandAmount)}`, { x: 495, y: yPosition, size: 9, font: calibriBold });

      // --- PAGINATION ---
      const allPages = pdfDoc.getPages();
      const totalPages = allPages.length;
      allPages.forEach((page, index) => {
        page.drawText(`Page ${index + 1} of ${totalPages}`, {
          x: 680,
          y: 580,
          size: 10,
          font: calibriBold,
        });
      });

      const modifiedPdfBytes = await pdfDoc.save();
      const blob = new Blob([modifiedPdfBytes], { type: "application/pdf" });
      const a = document.createElement("a");
      a.href = URL.createObjectURL(blob);
      a.download = `PURCHASE_ORDER_BY_VENDOR_SUMMARIZED.pdf`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);

    } catch (error) {
      console.error("Error:", error);
      setFailMessage("Error processing PDF");
    }
    setLoading(false);
  };

  const generatePurchaseOrderByDateDetailedHandleClick = async () => {
    if (!dateFrom || !dateTo || !company) {
      setFailMessage("Please fill up Date From, Date To, Company fields");
      return;
    }

    setLoading(true);
    const allData = await fetchReportData();
    const _data = allData?.byDateDetailed

    if (!_data || _data?.length <= 0) {
      setFailMessage("No record found");
      setLoading(false);
      return;
    }

    try {
      const pdfUrl = `${window.location.origin}/docs/PURCHASE_ORDER_BY_DATE_DETAILED.pdf`;
      const templateBytes = await fetch(pdfUrl).then(r => r.arrayBuffer());
      // Original template (never modified)
      const templateDoc = await PDFDocument.load(templateBytes);
      const response = await fetch(pdfUrl);
      const pdfBytes = await response.arrayBuffer();
      const pdfDoc = await PDFDocument.load(pdfBytes);

      pdfDoc.registerFontkit(fontkit);
      const fontResponse = await fetch("/calibri.ttf");
      const fontBytes = await fontResponse.arrayBuffer();
      const calibriFont = await pdfDoc.embedFont(fontBytes);

      const boldResponse = await fetch("/calibrib.ttf");
      const boldBytes = await boldResponse.arrayBuffer();
      const calibriBold = await pdfDoc.embedFont(boldBytes);

      const wrapText = (text, maxWidth, font, fontSize) => {
        if (!text) return [""];
        const words = text.split(" ");
        const lines = [];
        let currentLine = "";
        for (const word of words) {
          const testLine = currentLine ? `${currentLine} ${word}` : word;
          if (font.widthOfTextAtSize(testLine, fontSize) <= maxWidth) {
            currentLine = testLine;
          } else {
            if (currentLine) lines.push(currentLine);
            currentLine = word;
          }
        }
        if (currentLine) lines.push(currentLine);
        return lines;
      };

      const drawHeader = (targetPage) => {
        // Company Info
        targetPage.drawText(company.name?.toString() ?? "", { x: 35, y: 583, size: 16, font: calibriBold });
        targetPage.drawText(company.address?.toString() ?? "", { x: 35, y: 573, size: 8, font: calibriFont });
        targetPage.drawText(company.tin?.toString() ?? "", { x: 35, y: 563, size: 8, font: calibriFont });

        // Filters Info
        targetPage.drawText(`${FormatDateToWord(dateFrom)} to ${FormatDateToWord(dateTo)}`, { x: 83, y: 505.5, size: 8, font: calibriFont });
        targetPage.drawText(FormatDateToWord(new Date()), { x: 82, y: 494, size: 8, font: calibriFont });
      };

      let pages = pdfDoc.getPages();
      let currentPage = pages[0];
      drawHeader(currentPage);

      let yPosition = 450;
      const bottomThreshold = 80;
      const colWidthDesc = 180;
      const lineHeight = 20;

      let grandGrossVatable = 0;
      let grandVatable = 0;
      let grandVatAmount = 0;
      let grandAmount = 0;

      for (const record of _data) {
        let subGrossVatable = 0; 
        let subVatable = 0;
        let subVatAmount = 0;
        let subAmount = 0;

        currentPage.drawText(`${FormatDateToMDY(record.date)}`, { x: 40, y: yPosition, size: 8, font: calibriBold });
        currentPage.drawText(`${record.referenceNumber ?? ""}`, { x: 130, y: yPosition, size: 8, font: calibriBold });
        currentPage.drawText(`${record.vendorName1 ?? ""}`, { x: 245, y: yPosition, size: 8, font: calibriBold });
        yPosition -= 10

        for (const itemRow of record.items) {
          // --- PAGE BREAK CHECK ---
          if (yPosition < bottomThreshold) {
            const [templatePage] = await pdfDoc.copyPages(templateDoc, [0]);
            currentPage = pdfDoc.addPage(templatePage);
            drawHeader(currentPage);
            yPosition = 450;
          }

          // Draw Row Data

          const descLines = wrapText(itemRow.itemDescription, colWidthDesc, calibriFont, 8);
          for (let i = 0; i < descLines.length; i++) {
            currentPage.drawText(descLines[i], {
              x: 40,
              y: yPosition - i * lineHeight,
              size: 8,
              font: calibriFont,
            });
          }

          const qtyVal = parseFloat(itemRow.quantity) || 0;
          currentPage.drawText(`${FormatValueToDecimal(qtyVal)}`, { x: 195, y: yPosition, size: 8, font: calibriFont });
          currentPage.drawText(`${itemRow.uomName ?? ""}`, { x: 232, y: yPosition, size: 8, font: calibriFont });
          currentPage.drawText(FormatValueToDecimal(itemRow.unitPrice), { x: 278, y: yPosition, size: 8, font: calibriFont });
          currentPage.drawText(`${FormatValueToDecimal(itemRow.totalDiscount)}`, { x: 345, y: yPosition, size: 8, font: calibriFont });
          currentPage.drawText(`${FormatValueToDecimal(itemRow.netPrice)}`, { x: 410, y: yPosition, size: 8, font: calibriFont });
          currentPage.drawText(`${FormatValueToDecimal(itemRow.vaTableSales)}`, { x: 480, y: yPosition, size: 8, font: calibriFont });
          currentPage.drawText(`${FormatValueToDecimal(itemRow.vaTableSales)}`, { x: 553, y: yPosition, size: 8, font: calibriFont });
          currentPage.drawText(`${FormatValueToDecimal(itemRow.vat)}`, { x: 620, y: yPosition, size: 8, font: calibriFont });
          currentPage.drawText(`${FormatValueToDecimal(itemRow.totalAmount)}`, { x: 690, y: yPosition, size: 8, font: calibriFont });

          const rowHeight = Math.max(lineHeight, descLines.length * lineHeight);
          yPosition -= rowHeight + 5;

          subGrossVatable += itemRow.vaTableSales || 0;
          subVatable += itemRow.vaTableSales || 0;
          subVatAmount += itemRow.vat || 0;
          subAmount += itemRow.totalAmount || 0;

          grandGrossVatable += itemRow.vaTableSales || 0;
          grandVatable += itemRow.vaTableSales || 0;
          grandVatAmount += itemRow.vat || 0;
          grandAmount += itemRow.totalAmount || 0;
        }

          currentPage.drawLine({ start: { x: 35, y: yPosition + 10 }, end: { x: 757, y: yPosition + 10 }, thickness: 0.5 });

          currentPage.drawText(`Sub Total:  `, { x: 40, y: yPosition, size: 8, font: calibriBold });
          currentPage.drawText(`${FormatValueToDecimal(subGrossVatable)}`, { x: 480, y: yPosition, size: 8, font: calibriBold });
          currentPage.drawText(`${FormatValueToDecimal(subVatable)}`, { x: 553, y: yPosition, size: 8, font: calibriBold });
          currentPage.drawText(`${FormatValueToDecimal(subVatAmount)}`, { x: 620, y: yPosition, size: 8, font: calibriBold });
          currentPage.drawText(`${FormatValueToDecimal(subAmount)}`, { x: 690, y: yPosition, size: 8, font: calibriBold });

          yPosition -= 20;
      }

      // --- FOOTER SECTION ---
      if (yPosition < 150) {
        const [templatePage] = await pdfDoc.copyPages(templateDoc, [0]);
        currentPage = pdfDoc.addPage(templatePage);
        drawHeader(currentPage);
        yPosition = 450;
      }

      currentPage.drawLine({ start: { x: 35, y: yPosition }, end: { x: 757, y: yPosition }, thickness: 0.5 });
      yPosition -= 15;
      currentPage.drawText(`Grand Total:  `, { x: 40, y: yPosition, size: 8, font: calibriBold });
      currentPage.drawText(`${FormatValueToDecimal(grandGrossVatable)}`, { x: 480, y: yPosition, size: 8, font: calibriBold });
      currentPage.drawText(`${FormatValueToDecimal(grandVatable)}`, { x: 553, y: yPosition, size: 8, font: calibriBold });
      currentPage.drawText(`${FormatValueToDecimal(grandVatAmount)}`, { x: 620, y: yPosition, size: 8, font: calibriBold });
      currentPage.drawText(`${FormatValueToDecimal(grandAmount)}`, { x: 690, y: yPosition, size: 8, font: calibriBold });

      // --- PAGINATION POST-PROCESSING ---
      const allPages = pdfDoc.getPages();
      const totalPages = allPages.length;
      allPages.forEach((page, index) => {
        page.drawText(`Page ${index + 1} of ${totalPages}`, {
          x: 680, 
          y: 580,
          size: 10,
          font: calibriBold,
        });
      });

      const modifiedPdfBytes = await pdfDoc.save();
      const blob = new Blob([modifiedPdfBytes], { type: "application/pdf" });
      const a = document.createElement("a");
      a.href = URL.createObjectURL(blob);
      a.download = `PURCHASE_ORDER_BY_DATE_DETAILED.pdf`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    } catch (error) {
      console.error("Error:", error);
      setFailMessage("Error processing PDF");
    }
    setLoading(false);
  };

  const generatePurchaseOrderByDateSummarizedHandleClick = async () => {
    if (!dateFrom || !dateTo || !company) {
      setFailMessage("Please fill up Date From, Date To, Company fields");
      return;
    }

    setLoading(true);
    const allData = await fetchReportData();
    const _data = allData?.byDateDetailed

    if (!_data || _data?.length <= 0) {
      setFailMessage("No record found");
      setLoading(false);
      return;
    }

    try {
      const pdfUrl = `${window.location.origin}/docs/PURCHASE_ORDER_BY_DATE_SUMMARIZED.pdf`;
      const templateBytes = await fetch(pdfUrl).then(r => r.arrayBuffer());
      // Original template (never modified)
      const templateDoc = await PDFDocument.load(templateBytes);
      const response = await fetch(pdfUrl);
      const pdfBytes = await response.arrayBuffer();
      const pdfDoc = await PDFDocument.load(pdfBytes);

      pdfDoc.registerFontkit(fontkit);
      const fontResponse = await fetch("/calibri.ttf");
      const fontBytes = await fontResponse.arrayBuffer();
      const calibriFont = await pdfDoc.embedFont(fontBytes);

      const boldResponse = await fetch("/calibrib.ttf");
      const boldBytes = await boldResponse.arrayBuffer();
      const calibriBold = await pdfDoc.embedFont(boldBytes);

      const drawHeader = (targetPage) => {
        // Company Info
        targetPage.drawText(company.name?.toString() ?? "", { x: 35, y: 583, size: 16, font: calibriBold });
        targetPage.drawText(company.address?.toString() ?? "", { x: 35, y: 573, size: 8, font: calibriFont });
        targetPage.drawText(company.tin?.toString() ?? "", { x: 35, y: 563, size: 8, font: calibriFont });

        // Filters Info
        targetPage.drawText(`${FormatDateToWord(dateFrom)} to ${FormatDateToWord(dateTo)}`, { x: 83, y: 505.5, size: 8, font: calibriFont });
        targetPage.drawText(FormatDateToWord(new Date()), { x: 82, y: 494, size: 8, font: calibriFont });
      };

      const truncateText = (text, maxWidth, font, fontSize) => {
        if (!text) return "";
        let currentWidth = font.widthOfTextAtSize(text, fontSize);
        if (currentWidth <= maxWidth) return text;
        const ellipsis = "...";
        let truncated = text;
        while (truncated.length > 0 && font.widthOfTextAtSize(truncated + ellipsis, fontSize) > maxWidth) {
          truncated = truncated.slice(0, -1);
        }
        return truncated + ellipsis;
      };

      let pages = pdfDoc.getPages();
      let currentPage = pages[0];
      drawHeader(currentPage);

      let yPosition = 450;
      const bottomThreshold = 80;
      const lineHeight = 12;

      let grandGross = 0;
      let grandDiscount = 0;
      let grandGrossVatable = 0;
      let grandVatable = 0;
      let grandVatAmount = 0;
      let grandAmount = 0;

      for (const record of _data) {
        for (const itemRow of record.items) {
          // --- PAGE BREAK CHECK ---
          if (yPosition < bottomThreshold) {
            const [templatePage] = await pdfDoc.copyPages(templateDoc, [0]);
            currentPage = pdfDoc.addPage(templatePage);
            drawHeader(currentPage);
            yPosition = 450;
          }
          
          currentPage.drawText(FormatDateToWord(record.date), { x: 40, y: yPosition, size: 8, font: calibriFont });
          currentPage.drawText(`${record.referenceNumber ?? ""}`, { x: 100, y: yPosition, size: 8, font: calibriFont });
          
          const truncatedVendor = truncateText(record?.vendorName1 ?? "", 100, calibriFont, 8);
          currentPage.drawText(truncatedVendor, { x: 178, y: yPosition, size: 8, font: calibriFont });
          currentPage.drawText(`${record.terms ?? ""}`, { x: 277, y: yPosition, size: 8, font: calibriFont });

          currentPage.drawText(FormatValueToDecimal(itemRow.unitPrice), { x: 344, y: yPosition, size: 8, font: calibriFont });
          currentPage.drawText(`${FormatValueToDecimal(itemRow.totalDiscount)}`, { x: 407, y: yPosition, size: 8, font: calibriFont });
          currentPage.drawText(`${FormatValueToDecimal(itemRow.vaTableSales)}`, { x: 480, y: yPosition, size: 8, font: calibriFont });
          currentPage.drawText(`${FormatValueToDecimal(itemRow.vaTableSales)}`, { x: 553, y: yPosition, size: 8, font: calibriFont });
          currentPage.drawText(`${FormatValueToDecimal(itemRow.vat)}`, { x: 620, y: yPosition, size: 8, font: calibriFont });
          currentPage.drawText(`${FormatValueToDecimal(itemRow.totalAmount)}`, { x: 690, y: yPosition, size: 8, font: calibriFont });

          yPosition -= lineHeight;
          
          grandGross += itemRow.unitPrice || 0;
          grandDiscount += itemRow.totalDiscount || 0;
          grandGrossVatable += itemRow.vaTableSales || 0;
          grandVatable += itemRow.vaTableSales || 0;
          grandVatAmount += itemRow.vat || 0;
          grandAmount += itemRow.totalAmount || 0;
        }
      }

      // --- FOOTER SECTION ---
      if (yPosition < 150) {
        const [templatePage] = await pdfDoc.copyPages(templateDoc, [0]);
        currentPage = pdfDoc.addPage(templatePage);
        drawHeader(currentPage);
        yPosition = 450;
      }

      currentPage.drawLine({ start: { x: 35, y: yPosition }, end: { x: 757, y: yPosition }, thickness: 0.5 });
      yPosition -= 15;
      currentPage.drawText(`Grand Total:  `, { x: 40, y: yPosition, size: 8, font: calibriBold });
      currentPage.drawText(`${FormatValueToDecimal(grandGross)}`, { x: 344, y: yPosition, size: 8, font: calibriBold });
      currentPage.drawText(`${FormatValueToDecimal(grandDiscount)}`, { x: 407, y: yPosition, size: 8, font: calibriBold });
      currentPage.drawText(`${FormatValueToDecimal(grandGrossVatable)}`, { x: 480, y: yPosition, size: 8, font: calibriBold });
      currentPage.drawText(`${FormatValueToDecimal(grandVatable)}`, { x: 553, y: yPosition, size: 8, font: calibriBold });
      currentPage.drawText(`${FormatValueToDecimal(grandVatAmount)}`, { x: 620, y: yPosition, size: 8, font: calibriBold });
      currentPage.drawText(`${FormatValueToDecimal(grandAmount)}`, { x: 690, y: yPosition, size: 8, font: calibriBold });

      // --- PAGINATION POST-PROCESSING ---
      const allPages = pdfDoc.getPages();
      const totalPages = allPages.length;
      allPages.forEach((page, index) => {
        page.drawText(`Page ${index + 1} of ${totalPages}`, {
          x: 680, 
          y: 580,
          size: 10,
          font: calibriBold,
        });
      });

      const modifiedPdfBytes = await pdfDoc.save();
      const blob = new Blob([modifiedPdfBytes], { type: "application/pdf" });
      const a = document.createElement("a");
      a.href = URL.createObjectURL(blob);
      a.download = `PURCHASE_ORDER_BY_DATE_SUMMARIZED.pdf`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    } catch (error) {
      console.error("Error:", error);
      setFailMessage("Error processing PDF");
    }
    setLoading(false);
  };

  const generatePurchaseOrderByDocNoDetailedHandleClick = async () => {
    if (!dateFrom || !dateTo || !company) {
      setFailMessage("Please fill up Date From, Date To, Company fields");
      return;
    }

    setLoading(true);
    const allData = await fetchReportData();
    const _data = allData?.byDateDetailed

    if (!_data || _data?.length <= 0) {
      setFailMessage("No record found");
      setLoading(false);
      return;
    }

    try {
      const pdfUrl = `${window.location.origin}/docs/PURCHASE_ORDER_BY_DOC_NO_DETAILED.pdf`;
      const templateBytes = await fetch(pdfUrl).then(r => r.arrayBuffer());
      // Original template (never modified)
      const templateDoc = await PDFDocument.load(templateBytes);
      const response = await fetch(pdfUrl);
      const pdfBytes = await response.arrayBuffer();
      const pdfDoc = await PDFDocument.load(pdfBytes);

      pdfDoc.registerFontkit(fontkit);
      const fontResponse = await fetch("/calibri.ttf");
      const fontBytes = await fontResponse.arrayBuffer();
      const calibriFont = await pdfDoc.embedFont(fontBytes);

      const boldResponse = await fetch("/calibrib.ttf");
      const boldBytes = await boldResponse.arrayBuffer();
      const calibriBold = await pdfDoc.embedFont(boldBytes);

      const wrapText = (text, maxWidth, font, fontSize) => {
        if (!text) return [""];
        const words = text.split(" ");
        const lines = [];
        let currentLine = "";
        for (const word of words) {
          const testLine = currentLine ? `${currentLine} ${word}` : word;
          if (font.widthOfTextAtSize(testLine, fontSize) <= maxWidth) {
            currentLine = testLine;
          } else {
            if (currentLine) lines.push(currentLine);
            currentLine = word;
          }
        }
        if (currentLine) lines.push(currentLine);
        return lines;
      };

      const drawHeader = (targetPage) => {
        // Company Info
        targetPage.drawText(company.name?.toString() ?? "", { x: 35, y: 583, size: 16, font: calibriBold });
        targetPage.drawText(company.address?.toString() ?? "", { x: 35, y: 573, size: 8, font: calibriFont });
        targetPage.drawText(company.tin?.toString() ?? "", { x: 35, y: 563, size: 8, font: calibriFont });

        // Filters Info
        targetPage.drawText(`${FormatDateToWord(dateFrom)} to ${FormatDateToWord(dateTo)}`, { x: 83, y: 505.5, size: 8, font: calibriFont });
        targetPage.drawText(FormatDateToWord(new Date()), { x: 82, y: 494, size: 8, font: calibriFont });
      };

      let pages = pdfDoc.getPages();
      let currentPage = pages[0];
      drawHeader(currentPage);

      let yPosition = 450;
      const bottomThreshold = 80;
      const colWidthDesc = 180;
      const lineHeight = 20;

      let grandAmount = 0;

      for (const record of _data) {
        let subAmount = 0;

        currentPage.drawText(`${record.referenceNumber ?? ""}`, { x: 40, y: yPosition, size: 8, font: calibriBold });
        currentPage.drawText(`${FormatDateToMDY(record.date)}`, { x: 262, y: yPosition, size: 8, font: calibriBold });
        currentPage.drawText(`${record.vendorName1 ?? ""}`, { x: 307, y: yPosition, size: 8, font: calibriBold });
        yPosition -= 10

        for (const itemRow of record.items) {
          // --- PAGE BREAK CHECK ---
          if (yPosition < bottomThreshold) {
            const [templatePage] = await pdfDoc.copyPages(templateDoc, [0]);
            currentPage = pdfDoc.addPage(templatePage);
            drawHeader(currentPage);
            yPosition = 450;
          }

          // Draw Row Data

          const descLines = wrapText(itemRow.itemDescription, colWidthDesc, calibriFont, 8);
          for (let i = 0; i < descLines.length; i++) {
            currentPage.drawText(descLines[i], {
              x: 40,
              y: yPosition - i * lineHeight,
              size: 8,
              font: calibriFont,
            });
          }

          const qtyVal = parseFloat(itemRow.quantity) || 0;
          currentPage.drawText(`${FormatValueToDecimal(qtyVal)}`, { x: 262, y: yPosition, size: 8, font: calibriFont });
          currentPage.drawText(`${itemRow.uomName ?? ""}`, { x: 307, y: yPosition, size: 8, font: calibriFont });
          currentPage.drawText(FormatValueToDecimal(itemRow.unitPrice), { x: 362, y: yPosition, size: 8, font: calibriFont });
          currentPage.drawText(`${FormatValueToDecimal(itemRow.discountPercent)}`, { x: 443, y: yPosition, size: 8, font: calibriFont });
          currentPage.drawText(`${FormatValueToDecimal(itemRow.totalDiscount)}`, { x: 506, y: yPosition, size: 8, font: calibriFont });
          currentPage.drawText(`${FormatValueToDecimal(itemRow.netPrice)}`, { x: 588, y: yPosition, size: 8, font: calibriFont });
          currentPage.drawText(`${FormatValueToDecimal(itemRow.totalAmount)}`, { x: 675, y: yPosition, size: 8, font: calibriFont });

          const rowHeight = Math.max(lineHeight, descLines.length * lineHeight);
          yPosition -= rowHeight + 5;

          subAmount += itemRow.totalAmount || 0;

          grandAmount += itemRow.totalAmount || 0;
        }

          currentPage.drawLine({ start: { x: 35, y: yPosition + 10 }, end: { x: 757, y: yPosition + 10 }, thickness: 0.5 });

          currentPage.drawText(`Sub Total:  `, { x: 40, y: yPosition, size: 8, font: calibriBold });
          currentPage.drawText(`${FormatValueToDecimal(subAmount)}`, { x: 675, y: yPosition, size: 8, font: calibriBold });

          yPosition -= 20;
      }

      // --- FOOTER SECTION ---
      if (yPosition < 150) {
        const [templatePage] = await pdfDoc.copyPages(templateDoc, [0]);
        currentPage = pdfDoc.addPage(templatePage);
        drawHeader(currentPage);
        yPosition = 450;
      }

      currentPage.drawLine({ start: { x: 35, y: yPosition }, end: { x: 757, y: yPosition }, thickness: 0.5 });
      yPosition -= 15;
      currentPage.drawText(`Grand Total:  `, { x: 40, y: yPosition, size: 8, font: calibriBold });
      currentPage.drawText(`${FormatValueToDecimal(grandAmount)}`, { x: 675, y: yPosition, size: 8, font: calibriBold });

      // --- PAGINATION POST-PROCESSING ---
      const allPages = pdfDoc.getPages();
      const totalPages = allPages.length;
      allPages.forEach((page, index) => {
        page.drawText(`Page ${index + 1} of ${totalPages}`, {
          x: 680, 
          y: 580,
          size: 10,
          font: calibriBold,
        });
      });

      const modifiedPdfBytes = await pdfDoc.save();
      const blob = new Blob([modifiedPdfBytes], { type: "application/pdf" });
      const a = document.createElement("a");
      a.href = URL.createObjectURL(blob);
      a.download = `PURCHASE_ORDER_BY_DOC_NO_DETAILED.pdf`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    } catch (error) {
      console.error("Error:", error);
      setFailMessage("Error processing PDF");
    }
    setLoading(false);
  };

  const generatePurchaseOrderByDocNoSummarizedHandleClick = async () => {
    if (!dateFrom || !dateTo || !company) {
      setFailMessage("Please fill up Date From, Date To, Company fields");
      return;
    }

    setLoading(true);
    const allData = await fetchReportData();
    const _data = allData?.byDateDetailed

    if (!_data || _data?.length <= 0) {
      setFailMessage("No record found");
      setLoading(false);
      return;
    }

    try {
      const pdfUrl = `${window.location.origin}/docs/PURCHASE_ORDER_BY_DOC_NO_SUMMARIZED.pdf`;
      const templateBytes = await fetch(pdfUrl).then(r => r.arrayBuffer());
      // Original template (never modified)
      const templateDoc = await PDFDocument.load(templateBytes);
      const response = await fetch(pdfUrl);
      const pdfBytes = await response.arrayBuffer();
      const pdfDoc = await PDFDocument.load(pdfBytes);

      pdfDoc.registerFontkit(fontkit);
      const fontResponse = await fetch("/calibri.ttf");
      const fontBytes = await fontResponse.arrayBuffer();
      const calibriFont = await pdfDoc.embedFont(fontBytes);

      const boldResponse = await fetch("/calibrib.ttf");
      const boldBytes = await boldResponse.arrayBuffer();
      const calibriBold = await pdfDoc.embedFont(boldBytes);

      const drawHeader = (targetPage) => {
        // Company Info
        targetPage.drawText(company.name?.toString() ?? "", { x: 35, y: 583, size: 16, font: calibriBold });
        targetPage.drawText(company.address?.toString() ?? "", { x: 35, y: 573, size: 8, font: calibriFont });
        targetPage.drawText(company.tin?.toString() ?? "", { x: 35, y: 563, size: 8, font: calibriFont });

        // Filters Info
        targetPage.drawText(`${FormatDateToWord(dateFrom)} to ${FormatDateToWord(dateTo)}`, { x: 83, y: 505.5, size: 8, font: calibriFont });
        targetPage.drawText(FormatDateToWord(new Date()), { x: 82, y: 494, size: 8, font: calibriFont });
      };

      const truncateText = (text, maxWidth, font, fontSize) => {
        if (!text) return "";
        let currentWidth = font.widthOfTextAtSize(text, fontSize);
        if (currentWidth <= maxWidth) return text;
        const ellipsis = "...";
        let truncated = text;
        while (truncated.length > 0 && font.widthOfTextAtSize(truncated + ellipsis, fontSize) > maxWidth) {
          truncated = truncated.slice(0, -1);
        }
        return truncated + ellipsis;
      };

      let pages = pdfDoc.getPages();
      let currentPage = pages[0];
      drawHeader(currentPage);

      let yPosition = 450;
      const bottomThreshold = 80;
      const lineHeight = 12;

      let grandAmount = 0;

      for (const record of _data) {
        for (const itemRow of record.items) {
          // --- PAGE BREAK CHECK ---
          if (yPosition < bottomThreshold) {
            const [templatePage] = await pdfDoc.copyPages(templateDoc, [0]);
            currentPage = pdfDoc.addPage(templatePage);
            drawHeader(currentPage);
            yPosition = 450;
          }
          
          currentPage.drawText(`${record.referenceNumber ?? ""}`, { x: 40, y: yPosition, size: 8, font: calibriFont });
          currentPage.drawText(FormatDateToWord(record.date), { x: 135, y: yPosition, size: 8, font: calibriFont });
          
          const truncatedVendor = truncateText(record?.vendorName1 ?? "", 100, calibriFont, 8);
          currentPage.drawText(truncatedVendor, { x: 353, y: yPosition, size: 8, font: calibriFont });
          currentPage.drawText(`${record.terms ?? ""}`, { x: 523, y: yPosition, size: 8, font: calibriFont });

          currentPage.drawText(`${FormatValueToDecimal(itemRow.totalAmount)}`, { x: 640, y: yPosition, size: 8, font: calibriFont });

          yPosition -= lineHeight;
          
          grandAmount += itemRow.totalAmount || 0;
        }
      }

      // --- FOOTER SECTION ---
      if (yPosition < 150) {
        const [templatePage] = await pdfDoc.copyPages(templateDoc, [0]);
        currentPage = pdfDoc.addPage(templatePage);
        drawHeader(currentPage);
        yPosition = 450;
      }

      currentPage.drawLine({ start: { x: 35, y: yPosition }, end: { x: 757, y: yPosition }, thickness: 0.5 });
      yPosition -= 15;
      currentPage.drawText(`Grand Total:  `, { x: 40, y: yPosition, size: 8, font: calibriBold });
      currentPage.drawText(`${FormatValueToDecimal(grandAmount)}`, { x: 640, y: yPosition, size: 8, font: calibriBold });

      // --- PAGINATION POST-PROCESSING ---
      const allPages = pdfDoc.getPages();
      const totalPages = allPages.length;
      allPages.forEach((page, index) => {
        page.drawText(`Page ${index + 1} of ${totalPages}`, {
          x: 680, 
          y: 580,
          size: 10,
          font: calibriBold,
        });
      });

      const modifiedPdfBytes = await pdfDoc.save();
      const blob = new Blob([modifiedPdfBytes], { type: "application/pdf" });
      const a = document.createElement("a");
      a.href = URL.createObjectURL(blob);
      a.download = `PURCHASE_ORDER_BY_DOC_NO_SUMMARIZED.pdf`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    } catch (error) {
      console.error("Error:", error);
      setFailMessage("Error processing PDF");
    }
    setLoading(false);
  };

  const generatePurchaseOrderByItemDetailedHandleClick = async () => {
    if (!dateFrom || !dateTo || !company) {
      setFailMessage("Please fill up Date From, Date To, Company fields");
      return;
    }

    setLoading(true);
    const allData = await fetchReportData();
    const _data = allData?.byItemDetailed;

    if (!_data || _data?.length <= 0) {
      setFailMessage("No record found");
      setLoading(false);
      return;
    }

    try {
      const pdfUrl = `${window.location.origin}/docs/PURCHASE_ORDER_BY_ITEM_DETAILED.pdf`;
      const templateBytes = await fetch(pdfUrl).then((r) => r.arrayBuffer());
      const templateDoc = await PDFDocument.load(templateBytes);
      
      const response = await fetch(pdfUrl);
      const pdfBytes = await response.arrayBuffer();
      const pdfDoc = await PDFDocument.load(pdfBytes);

      pdfDoc.registerFontkit(fontkit);
      const fontResponse = await fetch("/calibri.ttf");
      const fontBytes = await fontResponse.arrayBuffer();
      const calibriFont = await pdfDoc.embedFont(fontBytes);

      const boldResponse = await fetch("/calibrib.ttf");
      const boldBytes = await boldResponse.arrayBuffer();
      const calibriBold = await pdfDoc.embedFont(boldBytes);

      const truncateText = (text, maxWidth, font, fontSize) => {
        if (!text) return "";
        let currentWidth = font.widthOfTextAtSize(text, fontSize);
        if (currentWidth <= maxWidth) return text;
        const ellipsis = "...";
        let truncated = text;
        while (truncated.length > 0 && font.widthOfTextAtSize(truncated + ellipsis, fontSize) > maxWidth) {
          truncated = truncated.slice(0, -1);
        }
        return truncated + ellipsis;
      };

      const drawHeader = (targetPage) => {
        targetPage.drawText(company.name?.toString() ?? "", { x: 35, y: 583, size: 16, font: calibriBold });
        targetPage.drawText(company.address?.toString() ?? "", { x: 35, y: 573, size: 8, font: calibriFont });
        targetPage.drawText(company.tin?.toString() ?? "", { x: 35, y: 563, size: 8, font: calibriFont });

        targetPage.drawText(vendor?.vendorName1?.toString() ?? "", { x: 74, y: 526, size: 8, font: calibriFont });
        targetPage.drawText(`${FormatDateToWord(dateFrom)} to ${FormatDateToWord(dateTo)}`, { x: 83, y: 515, size: 8, font: calibriFont });
        targetPage.drawText(`${item?.itemCode?.toString() ?? ""} ${item?.itemDescription?.toString() ?? ""}`, { x: 57, y: 506, size: 8, font: calibriFont });
        targetPage.drawText(FormatDateToWord(new Date()), { x: 82, y: 495, size: 8, font: calibriFont });
      };

      let pages = pdfDoc.getPages();
      let currentPage = pages[0];
      drawHeader(currentPage);

      let yPosition = 446;
      const bottomThreshold = 80;
      const lineHeight = 12;

      let grandAmount = 0;

      // Helper to handle page breaks
      const addNewPage = async () => {
        const [templatePage] = await pdfDoc.copyPages(templateDoc, [0]);
        currentPage = pdfDoc.addPage(templatePage);
        drawHeader(currentPage);
        yPosition = 446;
      };

      for (const record of _data) {
        // Check space for Customer Name Header
        if (yPosition < bottomThreshold + 20) await addNewPage();

        currentPage.drawText(`${record.description ?? ""}`, { x: 40, y: yPosition, size: 8, font: calibriBold });
        yPosition -= 15;

        for (const itemRow of record.items) {
          // --- PAGE BREAK CHECK FOR ITEM ROW ---
          if (yPosition < bottomThreshold) {
            await addNewPage();
          }

          // Draw Row Data
          currentPage.drawText(FormatDateToMDY(itemRow.date), { x: 40, y: yPosition, size: 8, font: calibriFont });
          currentPage.drawText(`${itemRow?.docNo ?? ""}`, { x: 102, y: yPosition, size: 8, font: calibriFont });

          const truncatedCustomer = truncateText(itemRow?.vendor ?? "", 120, calibriFont, 8);
          currentPage.drawText(truncatedCustomer, { x: 250, y: yPosition, size: 8, font: calibriFont });

          const qtyVal = parseFloat(itemRow.quantity) || 0;
          currentPage.drawText(`${FormatValueToDecimal(qtyVal)}`, { x: 400, y: yPosition, size: 8, font: calibriFont });
          currentPage.drawText(`${itemRow.uomName ?? ""}`, { x: 434, y: yPosition, size: 8, font: calibriFont });
          currentPage.drawText(`${FormatValueToDecimal(itemRow.unitPrice)}`, { x: 475, y: yPosition, size: 8, font: calibriFont });
          currentPage.drawText(`${FormatValueToDecimal(itemRow.discountPercent)} %`, { x: 535, y: yPosition, size: 8, font: calibriFont });
          currentPage.drawText(`${FormatValueToDecimal(itemRow.totalDiscount)}`, { x: 580, y: yPosition, size: 8, font: calibriFont });
          currentPage.drawText(`${FormatValueToDecimal(itemRow.netPrice)}`, { x: 632, y: yPosition, size: 8, font: calibriFont });
          currentPage.drawText(`${FormatValueToDecimal(itemRow.totalAmount)}`, { x: 696, y: yPosition, size: 8, font: calibriFont });

          yPosition -= lineHeight;
          grandAmount += itemRow.totalAmount || 0;
        }

        // --- PAGE BREAK CHECK FOR CUSTOMER SUB-TOTAL ---
        // We check if there's enough space for the line (5px) and the text (15px)
        if (yPosition < bottomThreshold + 30) {
          await addNewPage();
        }

        currentPage.drawLine({ start: { x: 35, y: yPosition }, end: { x: 757, y: yPosition }, thickness: 0.5 });
        yPosition -= 15;
        currentPage.drawText(`Item Sub-Total:  `, { x: 40, y: yPosition, size: 8, font: calibriBold });
        currentPage.drawText(`${FormatValueToDecimal(record.totalAmount)}`, { x: 696, y: yPosition, size: 8, font: calibriBold });
        
        yPosition -= 20; // Extra spacing between customers
      }

      // --- FOOTER SECTION (GRAND TOTAL) ---
      if (yPosition < 100) {
        await addNewPage();
      }

      currentPage.drawLine({ start: { x: 35, y: yPosition }, end: { x: 757, y: yPosition }, thickness: 1 });
      yPosition -= 15;
      currentPage.drawText(`Grand Total:  `, { x: 40, y: yPosition, size: 9, font: calibriBold });
      currentPage.drawText(`${FormatValueToDecimal(grandAmount)}`, { x: 696, y: yPosition, size: 9, font: calibriBold });

      // --- PAGINATION ---
      const allPages = pdfDoc.getPages();
      const totalPages = allPages.length;
      allPages.forEach((page, index) => {
        page.drawText(`Page ${index + 1} of ${totalPages}`, {
          x: 680,
          y: 580,
          size: 10,
          font: calibriBold,
        });
      });

      const modifiedPdfBytes = await pdfDoc.save();
      const blob = new Blob([modifiedPdfBytes], { type: "application/pdf" });
      const a = document.createElement("a");
      a.href = URL.createObjectURL(blob);
      a.download = `PURCHASE_ORDER_BY_ITEM_DETAILED.pdf`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);

    } catch (error) {
      console.error("Error:", error);
      setFailMessage("Error processing PDF");
    }
    setLoading(false);
  };

  const generatePurchaseOrderByItemSummarizedHandleClick = async () => {
    if (!dateFrom || !dateTo || !company) {
      setFailMessage("Please fill up Date From, Date To, Company fields");
      return;
    }

    setLoading(true);
    const allData = await fetchReportData();
    const _data = allData?.byItemDetailed

    if (!_data || _data?.length <= 0) {
      setFailMessage("No record found");
      setLoading(false);
      return;
    }

    try {
      const pdfUrl = `${window.location.origin}/docs/PURCHASE_ORDER_BY_ITEM_SUMMARIZED.pdf`;
      const templateBytes = await fetch(pdfUrl).then(r => r.arrayBuffer());
      // Original template (never modified)
      const templateDoc = await PDFDocument.load(templateBytes);
      const response = await fetch(pdfUrl);
      const pdfBytes = await response.arrayBuffer();
      const pdfDoc = await PDFDocument.load(pdfBytes);

      pdfDoc.registerFontkit(fontkit);
      const fontResponse = await fetch("/calibri.ttf");
      const fontBytes = await fontResponse.arrayBuffer();
      const calibriFont = await pdfDoc.embedFont(fontBytes);

      const boldResponse = await fetch("/calibrib.ttf");
      const boldBytes = await boldResponse.arrayBuffer();
      const calibriBold = await pdfDoc.embedFont(boldBytes);

      const drawHeader = (targetPage) => {
        // Company Info
        targetPage.drawText(company.name?.toString() ?? "", { x: 35, y: 761, size: 16, font: calibriBold });
        targetPage.drawText(company.address?.toString() ?? "", { x: 35, y: 751, size: 8, font: calibriFont });
        targetPage.drawText(company.tin?.toString() ?? "", { x: 35, y: 741, size: 8, font: calibriFont });

        // Filters Info
        targetPage.drawText(vendor?.vendorName1?.toString() ?? "", { x: 73, y: 706, size: 8, font: calibriFont });
        targetPage.drawText(`${FormatDateToWord(dateFrom)} to ${FormatDateToWord(dateTo)}`, { x: 92, y: 695, size: 8, font: calibriFont });
        targetPage.drawText(`${item?.itemCode?.toString() ?? ""} ${item?.itemDescription?.toString() ?? ""}`, { x: 57, y: 685.5, size: 8, font: calibriFont });
        targetPage.drawText(FormatDateToWord(new Date()), { x: 82, y: 674, size: 8, font: calibriFont });
      };

      let pages = pdfDoc.getPages();
      let currentPage = pages[0];
      drawHeader(currentPage);

      let yPosition = 633;
      const bottomThreshold = 80;

      let grandAmount = 0;

      for (const record of _data) {
        // --- PAGE BREAK CHECK ---
        if (yPosition < bottomThreshold) {
          const [templatePage] = await pdfDoc.copyPages(templateDoc, [0]);
          currentPage = pdfDoc.addPage(templatePage);
          drawHeader(currentPage);
          yPosition = 633;
        }

        currentPage.drawText(`${record.description ?? ""}`, { x: 40, y: yPosition, size: 8, font: calibriBold });

        const qtyVal = parseFloat(record.totalQuantity) || 0;
        currentPage.drawText(`${FormatValueToDecimal(qtyVal)}`, { x: 283, y: yPosition, size: 8, font: calibriFont });
        currentPage.drawText(`${record.uomName ?? ""}`, { x: 357, y: yPosition, size: 8, font: calibriFont });
        currentPage.drawText(`${FormatValueToDecimal(record.totalAmount)}`, { x: 431, y: yPosition, size: 8, font: calibriFont });

        yPosition -= 10;

        grandAmount += record.totalAmount || 0;
      }

      // --- FOOTER SECTION ---
      if (yPosition < 150) {
        const [templatePage] = await pdfDoc.copyPages(templateDoc, [0]);
        currentPage = pdfDoc.addPage(templatePage);
        drawHeader(currentPage);
        yPosition = 633;
      }

      currentPage.drawLine({ start: { x: 35, y: yPosition }, end: { x: 757, y: yPosition }, thickness: 0.5 });
      yPosition -= 15;
      currentPage.drawText(`Grand Total:  `, { x: 40, y: yPosition, size: 8, font: calibriBold });
      currentPage.drawText(`${FormatValueToDecimal(grandAmount)}`, { x: 431, y: yPosition, size: 8, font: calibriBold });

      // --- PAGINATION POST-PROCESSING ---
      const allPages = pdfDoc.getPages();
      const totalPages = allPages.length;
      allPages.forEach((page, index) => {
        page.drawText(`Page ${index + 1} of ${totalPages}`, {
          x: 515, 
          y: 761,
          size: 10,
          font: calibriBold,
        });
      });

      const modifiedPdfBytes = await pdfDoc.save();
      const blob = new Blob([modifiedPdfBytes], { type: "application/pdf" });
      const a = document.createElement("a");
      a.href = URL.createObjectURL(blob);
      a.download = `PURCHASE_ORDER_BY_ITEM_SUMMARIZED.pdf`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    } catch (error) {
      console.error("Error:", error);
      setFailMessage("Error processing PDF");
    }
    setLoading(false);
  };

  const generatePurchaseOrderByItemClassificationDetailedHandleClick = async () => {
    if (!dateFrom || !dateTo || !company) {
      setFailMessage("Please fill up Date From, Date To, Company fields");
      return;
    }

    setLoading(true);
    const allData = await fetchReportData();
    
    // Use the structure directly from the API/bulkData
    const categories = allData?.byItemClassificationDetailed || [];
    
    if (categories.length === 0) {
      setFailMessage("No record found");
      setLoading(false);
      return;
    }

    try {
      const pdfUrl = `${window.location.origin}/docs/PURCHASE_ORDER_BY_ITEM_CLASSIFICATION_DETAILED.pdf`;
      const templateBytes = await fetch(pdfUrl).then(r => r.arrayBuffer());
      const templateDoc = await PDFDocument.load(templateBytes);

      const pdfDoc = await PDFDocument.load(templateBytes);
      pdfDoc.registerFontkit(fontkit);
      
      const fontBytes = await fetch("/calibri.ttf").then(r => r.arrayBuffer());
      const calibriFont = await pdfDoc.embedFont(fontBytes);

      const boldBytes = await fetch("/calibrib.ttf").then(r => r.arrayBuffer());
      const calibriBold = await pdfDoc.embedFont(boldBytes);

      const truncateText = (text, maxWidth, font, fontSize) => {
        if (!text) return "";
        let currentWidth = font.widthOfTextAtSize(text, fontSize);
        if (currentWidth <= maxWidth) return text;
        const ellipsis = "...";
        let truncated = text;
        while (truncated.length > 0 && font.widthOfTextAtSize(truncated + ellipsis, fontSize) > maxWidth) {
          truncated = truncated.slice(0, -1);
        }
        return truncated + ellipsis;
      };

      const drawHeader = (targetPage) => {
        // Company Info
        targetPage.drawText(company.name?.toString() ?? "", { x: 35, y: 761, size: 16, font: calibriBold });
        targetPage.drawText(company.address?.toString() ?? "", { x: 35, y: 751, size: 8, font: calibriFont });
        targetPage.drawText(company.tin?.toString() ?? "", { x: 35, y: 741, size: 8, font: calibriFont });

        // Filters Info
        targetPage.drawText(`${FormatDateToWord(dateFrom)} to ${FormatDateToWord(dateTo)}`, { x: 92, y: 685.5, size: 8, font: calibriFont });
        targetPage.drawText(FormatDateToWord(new Date()), { x: 82, y: 674, size: 8, font: calibriFont });
      };

      let pages = pdfDoc.getPages();
      let currentPage = pages[0];
      drawHeader(currentPage);

      let yPosition = 633;
      const bottomThreshold = 50;
      const lineHeight = 12;

      // Grand Totals
      let grandNetAmount = 0;
      let grandAmount = 0;

      for (const category of categories) {
        // Check for new page before Category Name
        if (yPosition < 100) {
          const [templatePage] = await pdfDoc.copyPages(templateDoc, [0]);
          currentPage = pdfDoc.addPage(templatePage);
          drawHeader(currentPage);
          yPosition = 633;
        }

        // Draw Category Header (e.g., Mobilization, Cement)
        currentPage.drawText(category.categoryName || "No Category", { x: 35, y: yPosition, size: 8, font: calibriBold.italic ? calibriBold : calibriBold });
        yPosition -= 12;

        let categoryNet = 0;
        let categoryAmount = 0;

        for (const itemGroup of category.items) {
          // Draw Item Description (e.g., Cement Type 1)
          currentPage.drawText(itemGroup.itemDescription || "", { x: 35, y: yPosition, size: 8, font: calibriFont.italic ? calibriFont : calibriFont });
          yPosition -= 10;

          for (const detail of itemGroup.details) {
            if (yPosition < bottomThreshold) {
              const [templatePage] = await pdfDoc.copyPages(templateDoc, [0]);
              currentPage = pdfDoc.addPage(templatePage);
              drawHeader(currentPage);
              yPosition = 633;
            }

            const dateStr = detail.date ? FormatDateToMDY(detail.date) : "";
            currentPage.drawText(dateStr, { x: 35, y: yPosition, size: 7.5, font: calibriFont });
            currentPage.drawText(`${detail.docNo || ""}`, { x: 105, y: yPosition, size: 7.5, font: calibriFont });
            
            currentPage.drawText(truncateText(detail.vendor, 120, calibriFont, 7.5), { x: 180, y: yPosition, size: 7.5, font: calibriFont });
            
            currentPage.drawText(FormatValueToDecimal(detail.quantity), { x: 323, y: yPosition, size: 7.5, font: calibriFont, align: 'right' });
            currentPage.drawText(detail.uomName || "", { x: 380, y: yPosition, size: 7.5, font: calibriFont });
            
            // Financials
            currentPage.drawText(`${FormatValueToDecimal(detail.netPrice)}`, { x: 436, y: yPosition, size: 7.5, font: calibriFont });
            currentPage.drawText(`${FormatValueToDecimal(detail.totalAmount || 0)}`, { x: 510, y: yPosition, size: 7.5, font: calibriFont });

            yPosition -= lineHeight;

            // Increment Category Totals
            categoryNet += (detail.netPrice || 0);
            categoryAmount += (detail.totalAmount || 0);
          }
        }

        // Category Sub-Total Line
        currentPage.drawLine({ start: { x: 35, y: yPosition + 8 }, end: { x: 870, y: yPosition + 8 }, thickness: 0.5 });
        currentPage.drawText("Item Classification Sub-Total", { x: 35, y: yPosition, size: 8, font: calibriBold });
        
        currentPage.drawText(`${FormatValueToDecimal(categoryNet)}`, { x: 436, y: yPosition, size: 8, font: calibriBold });
        currentPage.drawText(`${FormatValueToDecimal(categoryNet)}`, { x: 510, y: yPosition, size: 8, font: calibriBold });

        // Update Grand Totals
        grandNetAmount += categoryNet;
        grandAmount += categoryAmount;

        yPosition -= 20; // Space before next Category
      }

      // Final Grand Total
      if (yPosition < 80) {
        const [templatePage] = await pdfDoc.copyPages(templateDoc, [0]);
        currentPage = pdfDoc.addPage(templatePage);
        drawHeader(currentPage);
        yPosition = 633;
      }
      
      currentPage.drawLine({ start: { x: 35, y: yPosition + 10 }, end: { x: 870, y: yPosition + 10 }, thickness: 1 });
      currentPage.drawText("GRAND TOTAL", { x: 35, y: yPosition, size: 9, font: calibriBold });
      currentPage.drawText(`${FormatValueToDecimal(grandNetAmount)}`, { x: 436, y: yPosition, size: 8, font: calibriBold });
      currentPage.drawText(`${FormatValueToDecimal(grandAmount)}`, { x: 510, y: yPosition, size: 8, font: calibriBold });

      // Page Numbers
      const allPages = pdfDoc.getPages();
      allPages.forEach((page, index) => {
        page.drawText(`Page : ${index + 1}`, { x: 820, y: 580, size: 9, font: calibriFont });
      });

      const modifiedPdfBytes = await pdfDoc.save();
      const blob = new Blob([modifiedPdfBytes], { type: "application/pdf" });
      const a = document.createElement("a");
      a.href = URL.createObjectURL(blob);
      a.download = `PURCHASE_ORDER_BY_ITEM_CLASSIFICATION_DETAILED_${FormatDateToMDY(new Date())}.pdf`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    } catch (error) {
      console.error("Error:", error);
      setFailMessage("Error processing PDF");
    }
    setLoading(false);
  };

  const generatePurchaseOrderByItemClassificationSummarizedHandleClick = async () => {
    if (!dateFrom || !dateTo || !company) {
      setFailMessage("Please fill up Date From, Date To, Company fields");
      return;
    }

    setLoading(true);
    const allData = await fetchReportData();
    
    // Use the structure directly from the API/bulkData
    const categories = allData?.byItemClassificationDetailed || [];
    
    if (categories.length === 0) {
      setFailMessage("No record found");
      setLoading(false);
      return;
    }

    try {
      const pdfUrl = `${window.location.origin}/docs/PURCHASE_ORDER_BY_ITEM_CLASSIFICATION_SUMMARIZED.pdf`;
      const templateBytes = await fetch(pdfUrl).then(r => r.arrayBuffer());
      const templateDoc = await PDFDocument.load(templateBytes);

      const pdfDoc = await PDFDocument.load(templateBytes);
      pdfDoc.registerFontkit(fontkit);
      
      const fontBytes = await fetch("/calibri.ttf").then(r => r.arrayBuffer());
      const calibriFont = await pdfDoc.embedFont(fontBytes);

      const boldBytes = await fetch("/calibrib.ttf").then(r => r.arrayBuffer());
      const calibriBold = await pdfDoc.embedFont(boldBytes);

      const drawHeader = (targetPage) => {
        // Company Info
        targetPage.drawText(company.name?.toString() ?? "", { x: 35, y: 761, size: 16, font: calibriBold });
        targetPage.drawText(company.address?.toString() ?? "", { x: 35, y: 751, size: 8, font: calibriFont });
        targetPage.drawText(company.tin?.toString() ?? "", { x: 35, y: 741, size: 8, font: calibriFont });

        // Filters Info
        targetPage.drawText(`${FormatDateToWord(dateFrom)} to ${FormatDateToWord(dateTo)}`, { x: 92, y: 685.5, size: 8, font: calibriFont });
        targetPage.drawText(FormatDateToWord(new Date()), { x: 82, y: 674, size: 8, font: calibriFont });
      };

      let pages = pdfDoc.getPages();
      let currentPage = pages[0];
      drawHeader(currentPage);

      let yPosition = 633;
      const bottomThreshold = 50;
      const lineHeight = 12;

      // Grand Totals
      let grandNetAmount = 0;
      let grandAmount = 0;

      for (const category of categories) {
        // Check for new page before Category Name
        if (yPosition < 100) {
          const [templatePage] = await pdfDoc.copyPages(templateDoc, [0]);
          currentPage = pdfDoc.addPage(templatePage);
          drawHeader(currentPage);
          yPosition = 633;
        }

        // Draw Category Header (e.g., Mobilization, Cement)
        currentPage.drawText(category.categoryName || "No Category", { x: 35, y: yPosition, size: 8, font: calibriBold.italic ? calibriBold : calibriBold });
        yPosition -= 12;

        let categoryNet = 0;
        let categoryAmount = 0;

        for (const itemGroup of category.items) {
          for (const detail of itemGroup.details) {
            if (yPosition < bottomThreshold) {
              const [templatePage] = await pdfDoc.copyPages(templateDoc, [0]);
              currentPage = pdfDoc.addPage(templatePage);
              drawHeader(currentPage);
              yPosition = 633;
            }

            currentPage.drawText(itemGroup.itemDescription || "", { x: 35, y: yPosition, size: 8, font: calibriFont.italic ? calibriFont : calibriFont });
            
            currentPage.drawText(FormatValueToDecimal(detail.quantity), { x: 267, y: yPosition, size: 7.5, font: calibriFont, align: 'right' });
            currentPage.drawText(detail.uomName || "", { x: 340, y: yPosition, size: 7.5, font: calibriFont });
            
            // Financials
            currentPage.drawText(`${FormatValueToDecimal(detail.netPrice)}`, { x: 395, y: yPosition, size: 7.5, font: calibriFont });
            currentPage.drawText(`${FormatValueToDecimal(detail.totalAmount || 0)}`, { x: 495, y: yPosition, size: 7.5, font: calibriFont });

            yPosition -= lineHeight;

            // Increment Category Totals
            categoryNet += (detail.netPrice || 0);
            categoryAmount += (detail.totalAmount || 0);
          }
        }

        // Category Sub-Total Line
        currentPage.drawLine({ start: { x: 35, y: yPosition + 8 }, end: { x: 870, y: yPosition + 8 }, thickness: 0.5 });
        currentPage.drawText("Item Classification Sub-Total", { x: 35, y: yPosition, size: 8, font: calibriBold });
        
        currentPage.drawText(`${FormatValueToDecimal(categoryNet)}`, { x: 395, y: yPosition, size: 8, font: calibriBold });
        currentPage.drawText(`${FormatValueToDecimal(categoryNet)}`, { x: 495, y: yPosition, size: 8, font: calibriBold });

        // Update Grand Totals
        grandNetAmount += categoryNet;
        grandAmount += categoryAmount;

        yPosition -= 20; // Space before next Category
      }

      // Final Grand Total
      if (yPosition < 80) {
        const [templatePage] = await pdfDoc.copyPages(templateDoc, [0]);
        currentPage = pdfDoc.addPage(templatePage);
        drawHeader(currentPage);
        yPosition = 633;
      }
      
      currentPage.drawLine({ start: { x: 35, y: yPosition + 10 }, end: { x: 870, y: yPosition + 10 }, thickness: 1 });
      currentPage.drawText("GRAND TOTAL", { x: 35, y: yPosition, size: 9, font: calibriBold });
      currentPage.drawText(`${FormatValueToDecimal(grandNetAmount)}`, { x: 395, y: yPosition, size: 8, font: calibriBold });
      currentPage.drawText(`${FormatValueToDecimal(grandAmount)}`, { x: 495, y: yPosition, size: 8, font: calibriBold });

      // Page Numbers
      const allPages = pdfDoc.getPages();
      allPages.forEach((page, index) => {
        page.drawText(`Page : ${index + 1}`, { x: 820, y: 580, size: 9, font: calibriFont });
      });

      const modifiedPdfBytes = await pdfDoc.save();
      const blob = new Blob([modifiedPdfBytes], { type: "application/pdf" });
      const a = document.createElement("a");
      a.href = URL.createObjectURL(blob);
      a.download = `PURCHASE_ORDER_BY_ITEM_CLASSIFICATION_SUMMARIZED_${FormatDateToMDY(new Date())}.pdf`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    } catch (error) {
      console.error("Error:", error);
      setFailMessage("Error processing PDF");
    }
    setLoading(false);
  };

  const generatePurchaseOrderByItemVendorDetailedHandleClick = async () => {
    if (!dateFrom || !dateTo || !company) {
      setFailMessage("Please fill up Date From, Date To, Company fields");
      return;
    }

    setLoading(true);
    const allData = await fetchReportData();
    
    // This matches the Nested C# structure: Items -> Vendors -> Transactions
    const groupedData = allData?.byItemVendorDetailed || [];
    
    if (groupedData.length === 0) {
      setFailMessage("No record found");
      setLoading(false);
      return;
    }

    try {
      const pdfUrl = `${window.location.origin}/docs/PURCHASE_ORDER_BY_ITEM_VENDOR_DETAILED.pdf`;
      const templateBytes = await fetch(pdfUrl).then(r => r.arrayBuffer());
      const templateDoc = await PDFDocument.load(templateBytes);

      const pdfDoc = await PDFDocument.load(templateBytes);
      pdfDoc.registerFontkit(fontkit);
      
      const fontBytes = await fetch("/calibri.ttf").then(r => r.arrayBuffer());
      const calibriFont = await pdfDoc.embedFont(fontBytes);

      const boldBytes = await fetch("/calibrib.ttf").then(r => r.arrayBuffer());
      const calibriBold = await pdfDoc.embedFont(boldBytes);

      const truncateText = (text, maxWidth, font, fontSize) => {
        if (!text) return "";
        let currentWidth = font.widthOfTextAtSize(text, fontSize);
        if (currentWidth <= maxWidth) return text;
        const ellipsis = "...";
        let truncated = text;
        while (truncated.length > 0 && font.widthOfTextAtSize(truncated + ellipsis, fontSize) > maxWidth) {
          truncated = truncated.slice(0, -1);
        }
        return truncated + ellipsis;
      };

      const drawHeader = (targetPage) => {
        targetPage.drawText(company.name?.toString() ?? "", { x: 35, y: 761, size: 16, font: calibriBold });
        targetPage.drawText(company.address?.toString() ?? "", { x: 35, y: 751, size: 8, font: calibriFont });
        targetPage.drawText(company.tin?.toString() ?? "", { x: 35, y: 741, size: 8, font: calibriFont });
        targetPage.drawText(`${FormatDateToWord(dateFrom)} to ${FormatDateToWord(dateTo)}`, { x: 92, y: 685.5, size: 8, font: calibriFont });
        targetPage.drawText(FormatDateToWord(new Date()), { x: 82, y: 674, size: 8, font: calibriFont });
      };

      let pages = pdfDoc.getPages();
      let currentPage = pages[0];
      drawHeader(currentPage);

      let yPosition = 633;
      const bottomThreshold = 60;
      const lineHeight = 12;

      // Column X-Positions (Adjusted to match your image layout)
      const colSupplier = 55;
      const colDate = 156;
      const colDoc = 227;
      const colQty = 307;      // Right aligned end
      const colUom = 353;
      const colVatable = 400;  // Right aligned end
      const colVatAmt = 461;   // Right aligned end
      const colAmount = 525;   // Right aligned end
      const endline = 590;

      let grandTotalAmount = 0;

      for (const itemGroup of groupedData) {
        // 1. Check for page break before Item Header
        if (yPosition < 100) {
          const [templatePage] = await pdfDoc.copyPages(templateDoc, [0]);
          currentPage = pdfDoc.addPage(templatePage);
          drawHeader(currentPage);
          yPosition = 633;
        }

        // 2. Draw ITEM NAME (e.g., Diesel)
        currentPage.drawText(itemGroup.itemDescription || "Unknown Item", { x: 35, y: yPosition, size: 8.5, font: calibriBold });
        yPosition -= lineHeight;

        for (const vendor of itemGroup.vendors) {
          // 3. Draw VENDOR NAME
          // currentPage.drawText(vendor.vendorName || "", { x: colSupplier, y: yPosition, size: 8, font: calibriFont });

          const truncatedVendor = truncateText(vendor.vendorName ?? "", 100, calibriFont, 8);
          currentPage.drawText(truncatedVendor, { x: colSupplier, y: yPosition, size: 8, font: calibriFont });

          for (const detail of vendor.transactions) {
            if (yPosition < bottomThreshold) {
              const [templatePage] = await pdfDoc.copyPages(templateDoc, [0]);
              currentPage = pdfDoc.addPage(templatePage);
              drawHeader(currentPage);
              yPosition = 633;
            }

            const dateStr = detail.date ? FormatDateToMDY(detail.date) : "";
            currentPage.drawText(dateStr, { x: colDate, y: yPosition, size: 7.5, font: calibriFont });
            currentPage.drawText(`${detail.docNo || ""}`, { x: colDoc, y: yPosition, size: 7.5, font: calibriFont });
            
            // Right-aligned numeric columns
            currentPage.drawText(`${FormatValueToDecimal(detail.quantity)}`, { x: colQty, y: yPosition, size: 7.5, font: calibriFont });
            currentPage.drawText(detail.uomName || "", { x: colUom, y: yPosition, size: 7.5, font: calibriFont });
            currentPage.drawText(`${FormatValueToDecimal(detail.vatable)}`, { x: colVatable, y: yPosition, size: 7.5, font: calibriFont });
            currentPage.drawText(`${FormatValueToDecimal(detail.vatAmount)}`, { x: colVatAmt, y: yPosition, size: 7.5, font: calibriFont });
            currentPage.drawText(`${FormatValueToDecimal(detail.totalAmount)}`, { x: colAmount, y: yPosition, size: 7.5, font: calibriFont });

            yPosition -= lineHeight;
          }

          // 4. Vendor Sub-total (Line + Bold Amount)
          yPosition += 2;
          currentPage.drawLine({ start: { x: colAmount - 10, y: yPosition }, end: { x: endline, y: yPosition }, thickness: 0.5 });
          yPosition -= 10;
          currentPage.drawText(`${FormatValueToDecimal(vendor.vendorSubTotal)}`, { x: colAmount, y: yPosition, size: 7.5, font: calibriFont });
          yPosition -= 15;
        }

        // 5. ITEM SUB-TOTAL SECTION (Gray-like bars in image)
        if (yPosition < 80) {
          const [templatePage] = await pdfDoc.copyPages(templateDoc, [0]);
          currentPage = pdfDoc.addPage(templatePage);
          drawHeader(currentPage);
          yPosition = 633;
        }

        // Horizontal lines for Item Sub-total
        currentPage.drawLine({ start: { x: 35, y: yPosition + 10 }, end: { x: endline, y: yPosition + 10 }, thickness: 1 });
        currentPage.drawText("Item Sub-Total :", { x: 35, y: yPosition, size: 8.5, font: calibriBold });
        currentPage.drawText(`${FormatValueToDecimal(itemGroup?.itemSubTotal || 0)}`, { x: colAmount, y: yPosition, size: 7.5, font: calibriFont });
        currentPage.drawLine({ start: { x: 35, y: yPosition - 4 }, end: { x: endline, y: yPosition - 4 }, thickness: 1 });

        grandTotalAmount += itemGroup.itemSubTotal;
        yPosition -= 30; // Space before next Item
      }

      // 6. GRAND TOTAL
      if (yPosition < 60) {
        const [templatePage] = await pdfDoc.copyPages(templateDoc, [0]);
        currentPage = pdfDoc.addPage(templatePage);
        drawHeader(currentPage);
        yPosition = 633;
      }
      currentPage.drawText("GRAND TOTAL", { x: 35, y: yPosition, size: 10, font: calibriBold });
      currentPage.drawText(`${FormatValueToDecimal(grandTotalAmount)}`, { x: colAmount, y: yPosition, size: 7.5, font: calibriFont });

      // Page Numbers
      const allPages = pdfDoc.getPages();
      allPages.forEach((page, index) => {
        page.drawText(`Page : ${index + 1}`, { x: 700, y: 660, size: 9, font: calibriFont });
      });

      const modifiedPdfBytes = await pdfDoc.save();
      const blob = new Blob([modifiedPdfBytes], { type: "application/pdf" });
      const a = document.createElement("a");
      a.href = URL.createObjectURL(blob);
      a.download = `PURCHASE_ORDER_BY_ITEM_VENDOR_DETAILED_${FormatDateToMDY(new Date())}.pdf`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);

    } catch (error) {
      console.error("Error:", error);
      setFailMessage("Error processing PDF");
    }
    setLoading(false);
  };

  const generatePurchaseOrderByItemVendorSummarizedHandleClick = async () => {
    if (!dateFrom || !dateTo || !company) {
      setFailMessage("Please fill up Date From, Date To, Company fields");
      return;
    }

    setLoading(true);
    const allData = await fetchReportData();
    
    // This matches the Nested C# structure: Items -> Vendors -> Transactions
    const groupedData = allData?.byItemVendorDetailed || [];
    
    if (groupedData.length === 0) {
      setFailMessage("No record found");
      setLoading(false);
      return;
    }

    try {
      const pdfUrl = `${window.location.origin}/docs/PURCHASE_ORDER_BY_ITEM_VENDOR_SUMMARIZED.pdf`;
      const templateBytes = await fetch(pdfUrl).then(r => r.arrayBuffer());
      const templateDoc = await PDFDocument.load(templateBytes);

      const pdfDoc = await PDFDocument.load(templateBytes);
      pdfDoc.registerFontkit(fontkit);
      
      const fontBytes = await fetch("/calibri.ttf").then(r => r.arrayBuffer());
      const calibriFont = await pdfDoc.embedFont(fontBytes);

      const boldBytes = await fetch("/calibrib.ttf").then(r => r.arrayBuffer());
      const calibriBold = await pdfDoc.embedFont(boldBytes);

      const truncateText = (text, maxWidth, font, fontSize) => {
        if (!text) return "";
        let currentWidth = font.widthOfTextAtSize(text, fontSize);
        if (currentWidth <= maxWidth) return text;
        const ellipsis = "...";
        let truncated = text;
        while (truncated.length > 0 && font.widthOfTextAtSize(truncated + ellipsis, fontSize) > maxWidth) {
          truncated = truncated.slice(0, -1);
        }
        return truncated + ellipsis;
      };

      const drawHeader = (targetPage) => {
        targetPage.drawText(company.name?.toString() ?? "", { x: 35, y: 761, size: 16, font: calibriBold });
        targetPage.drawText(company.address?.toString() ?? "", { x: 35, y: 751, size: 8, font: calibriFont });
        targetPage.drawText(company.tin?.toString() ?? "", { x: 35, y: 741, size: 8, font: calibriFont });
        targetPage.drawText(`${FormatDateToWord(dateFrom)} to ${FormatDateToWord(dateTo)}`, { x: 92, y: 685.5, size: 8, font: calibriFont });
        targetPage.drawText(FormatDateToWord(new Date()), { x: 82, y: 674, size: 8, font: calibriFont });
      };

      let pages = pdfDoc.getPages();
      let currentPage = pages[0];
      drawHeader(currentPage);

      let yPosition = 633;
      const bottomThreshold = 60;
      const lineHeight = 12;

      // Column X-Positions (Adjusted to match your image layout)
      const colSupplier = 40;
      const colAmount = 400;   // Right aligned end
      const endline = 590;

      let grandTotalAmount = 0;

      for (const itemGroup of groupedData) {
        // 1. Check for page break before Item Header
        if (yPosition < 100) {
          const [templatePage] = await pdfDoc.copyPages(templateDoc, [0]);
          currentPage = pdfDoc.addPage(templatePage);
          drawHeader(currentPage);
          yPosition = 633;
        }

        // 2. Draw ITEM NAME (e.g., Diesel)
        currentPage.drawText(itemGroup.itemDescription || "Unknown Item", { x: 40, y: yPosition, size: 8.5, font: calibriBold });
        yPosition -= lineHeight;

        for (const vendor of itemGroup.vendors) {
          // 3. Draw VENDOR NAME
          // currentPage.drawText(vendor.vendorName || "", { x: colSupplier, y: yPosition, size: 8, font: calibriFont });

          const truncatedVendor = truncateText(vendor.vendorName ?? "", 100, calibriFont, 8);
          currentPage.drawText(truncatedVendor, { x: colSupplier, y: yPosition, size: 8, font: calibriFont });

          for (const detail of vendor.transactions) {
            if (yPosition < bottomThreshold) {
              const [templatePage] = await pdfDoc.copyPages(templateDoc, [0]);
              currentPage = pdfDoc.addPage(templatePage);
              drawHeader(currentPage);
              yPosition = 633;
            }

            currentPage.drawText(`${FormatValueToDecimal(detail.totalAmount)}`, { x: colAmount, y: yPosition, size: 7.5, font: calibriFont });

            yPosition -= lineHeight;
          }

          // 4. Vendor Sub-total (Line + Bold Amount)
          // yPosition += 2;
          // currentPage.drawLine({ start: { x: colAmount - 10, y: yPosition }, end: { x: endline, y: yPosition }, thickness: 0.5 });
          // yPosition -= 10;
          // currentPage.drawText(`${FormatValueToDecimal(vendor.vendorSubTotal)}`, { x: colAmount, y: yPosition, size: 7.5, font: calibriFont });
          // yPosition -= 15;
        }

        // 5. ITEM SUB-TOTAL SECTION (Gray-like bars in image)
        if (yPosition < 80) {
          const [templatePage] = await pdfDoc.copyPages(templateDoc, [0]);
          currentPage = pdfDoc.addPage(templatePage);
          drawHeader(currentPage);
          yPosition = 633;
        }

        // Horizontal lines for Item Sub-total
        currentPage.drawLine({ start: { x: 35, y: yPosition + 10 }, end: { x: endline, y: yPosition + 10 }, thickness: 1 });
        currentPage.drawText("Item Sub-Total :", { x: 40, y: yPosition, size: 8.5, font: calibriBold });
        currentPage.drawText(`${FormatValueToDecimal(itemGroup?.itemSubTotal || 0)}`, { x: colAmount, y: yPosition, size: 7.5, font: calibriFont });
        currentPage.drawLine({ start: { x: 35, y: yPosition - 4 }, end: { x: endline, y: yPosition - 4 }, thickness: 1 });

        grandTotalAmount += itemGroup.itemSubTotal;
        yPosition -= 30; // Space before next Item
      }

      // 6. GRAND TOTAL
      if (yPosition < 60) {
        const [templatePage] = await pdfDoc.copyPages(templateDoc, [0]);
        currentPage = pdfDoc.addPage(templatePage);
        drawHeader(currentPage);
        yPosition = 633;
      }
      currentPage.drawText("GRAND TOTAL", { x: 40, y: yPosition, size: 10, font: calibriBold });
      currentPage.drawText(`${FormatValueToDecimal(grandTotalAmount)}`, { x: colAmount, y: yPosition, size: 7.5, font: calibriFont });

      // Page Numbers
      const allPages = pdfDoc.getPages();
      allPages.forEach((page, index) => {
        page.drawText(`Page : ${index + 1}`, { x: 700, y: 660, size: 9, font: calibriFont });
      });

      const modifiedPdfBytes = await pdfDoc.save();
      const blob = new Blob([modifiedPdfBytes], { type: "application/pdf" });
      const a = document.createElement("a");
      a.href = URL.createObjectURL(blob);
      a.download = `PURCHASE_ORDER_BY_ITEM_VENDOR_SUMMARIZED_${FormatDateToMDY(new Date())}.pdf`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);

    } catch (error) {
      console.error("Error:", error);
      setFailMessage("Error processing PDF");
    }
    setLoading(false);
  };

  //Excel
  const exportPurchaseOrderByVendorDetailedExcel = async () => {
    if (!dateFrom || !dateTo || !company) {
      setFailMessage("Please fill up Date From, Date To, Company fields");
      return;
    }

    setLoading(true);

    try {
      const allData = await fetchReportData();
      const _data = allData?.byVendorDetailed;

      if (!_data || _data?.length <= 0) {
        setFailMessage("No record found");
        setLoading(false);
        return;
      }

      // 1. Create Workbook and Worksheet
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('PO Detailed by Vendor');

      // 2. Add Company Header Information
      worksheet.addRow([company.name?.toUpperCase()]).font = { bold: true, size: 14 };
      worksheet.addRow([company.address]);
      worksheet.addRow([`TIN: ${company.tin}`]);
      worksheet.addRow([]); // Gap

      // 3. Add Report Specific Info
      worksheet.addRow(['PURCHASE ORDER BY VENDOR (DETAILED)']).font = { bold: true };
      worksheet.addRow([`Period: ${FormatDateToWord(dateFrom)} to ${FormatDateToWord(dateTo)}`]);
      worksheet.addRow([`Date Printed: ${FormatDateToWord(new Date())}`]);
      worksheet.addRow([]); // Gap

      // 4. Define Table Columns
      const headerRow = worksheet.addRow([
        'Date',
        'Doc. No.',
        'Ref. No.',
        'Item',
        'Qty',
        'UOM',
        'Gross Price',
        'Disc %',
        'Dis. Amt.',
        'Net Price',
        'Amount'
      ]);

      // Style the Header Row
      headerRow.eachCell((cell) => {
        cell.font = { bold: true, color: { argb: 'FFFFFF' } };
        cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '444444' } };
        cell.alignment = { vertical: 'middle', horizontal: 'center' };
        cell.border = { 
            top: { style: 'thin' },
            left: { style: 'thin' },
            bottom: { style: 'thin' },
            right: { style: 'thin' } 
        };
      });

      // 5. Add Data Rows
      let grandAmount = 0;

      _data.forEach(record => {
        // Add a row for the Vendor Name (Header for the section)
        const vendorHeaderRow = worksheet.addRow([record.vendorName]);
        vendorHeaderRow.font = { bold: true };
        vendorHeaderRow.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'F2F2F2' } };
        
        // Merge vendor name across first few cells
        worksheet.mergeCells(`A${vendorHeaderRow.number}:C${vendorHeaderRow.number}`);

        record.orders.forEach(order => {
          order.items.forEach(itemRow => {
            const row = worksheet.addRow([
              FormatDateToMDY(order.date),
              order.referenceNumber?.toString(),
              "",
              itemRow.itemDescription,
              parseFloat(itemRow.quantity || 0),
              itemRow.uomName,
              parseFloat(itemRow.unitPrice || 0),
              parseFloat(itemRow.discountPercent || 0) / 100, // Excel handles % as decimals
              parseFloat(itemRow.totalDiscount || 0),
              parseFloat(itemRow.netPrice || 0),
              parseFloat(itemRow.totalAmount || 0),
            ]);

            // Apply Number Formatting
            row.getCell(5).numFmt = '#,##0.00'; // Qty
            row.getCell(7).numFmt = '#,##0.00'; // Unit Price
            row.getCell(8).numFmt = '0.00%';    // Disc %
            row.getCell(9).numFmt = '#,##0.00'; // Total Disc
            row.getCell(10).numFmt = '#,##0.00'; // Net Price
            row.getCell(11).numFmt = '#,##0.00'; // Total Amount
            
            // Text alignment for description
            row.getCell(3).alignment = { wrapText: true };
          });
        });

        // 6. Add Vendor Sub-Total Row
        const subTotalRow = worksheet.addRow([
          `Supplier Sub-Total:`, '', '', '', '', '', '', '', '', '',
          parseFloat(record.totalAmount || 0)
        ]);
        
        subTotalRow.font = { bold: true, italic: true };
        subTotalRow.getCell(11).numFmt = '#,##0.00';
        subTotalRow.getCell(11).border = { 
            top: { style: 'thin' },
            bottom: { style: 'thin' } 
        };
        
        grandAmount += parseFloat(record.totalAmount || 0);
        worksheet.addRow([]); // Blank line after each vendor section
      });

      // 7. Add Grand Totals Footer
      const grandTotalRow = worksheet.addRow([
        'GRAND TOTAL', '', '', '', '', '', '', '', '', '',
        grandAmount
      ]);

      grandTotalRow.font = { bold: true, size: 12 };
      grandTotalRow.getCell(11).numFmt = '#,##0.00';
      grandTotalRow.getCell(11).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFF00' } }; // Yellow highlight
      grandTotalRow.getCell(11).border = { 
        top: { style: 'thin' }, 
        bottom: { style: 'double' } 
      };

      // 8. Adjust Column Widths
      worksheet.columns = [
        { width: 12 }, // Date
        { width: 15 }, // Doc No
        { width: 15 }, // Doc No
        { width: 35 }, // Item Description
        { width: 10 }, // Qty
        { width: 10 }, // UOM
        { width: 12 }, // Unit Price
        { width: 10 }, // Disc %
        { width: 15 }, // Total Disc
        { width: 15 }, // Net Price
        { width: 18 }, // Total Amount
      ];

      // 9. Generate and Download File
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const filename = `Purchase_Order_Vendor_Detailed_${new Date().getTime()}.xlsx`;
      
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = filename;
      link.click();
      URL.revokeObjectURL(link.href);

    } catch (error) {
      console.error("Excel Error:", error);
      setFailMessage("Error generating Excel file");
    }

    setLoading(false);
  };

  const exportPurchaseOrderByVendorSummarizedExcel = async () => {
    if (!dateFrom || !dateTo || !company) {
      setFailMessage("Please fill up Date From, Date To, Company fields");
      return;
    }

    setLoading(true);

    try {
      const allData = await fetchReportData();
      const _data = allData?.byVendorDetailed; // Using the same data source as your PDF

      if (!_data || _data?.length <= 0) {
        setFailMessage("No record found");
        setLoading(false);
        return;
      }

      // 1. Create Workbook and Worksheet
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('PO Summarized by Vendor');

      // 2. Add Company Header Information
      worksheet.addRow([company.name?.toUpperCase()]).font = { bold: true, size: 14 };
      worksheet.addRow([company.address]);
      worksheet.addRow([`TIN: ${company.tin}`]);
      worksheet.addRow([]); // Gap

      // 3. Add Report Specific Info
      worksheet.addRow(['PURCHASE ORDER BY VENDOR (SUMMARIZED)']).font = { bold: true };
      worksheet.addRow([`Period: ${FormatDateToWord(dateFrom)} to ${FormatDateToWord(dateTo)}`]);
      worksheet.addRow([`Date Printed: ${FormatDateToWord(new Date())}`]);
      worksheet.addRow([]); // Gap

      // 4. Define Table Columns (Date, Doc No, Terms, Amount)
      const headerRow = worksheet.addRow([
        'Date',
        'Doc. No.',
        'Ref. No.',
        'Terms',
        'Amount'
      ]);

      // Style the Header Row
      headerRow.eachCell((cell) => {
        cell.font = { bold: true, color: { argb: 'FFFFFF' } };
        cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '444444' } };
        cell.alignment = { vertical: 'middle', horizontal: 'center' };
        cell.border = { 
            top: { style: 'thin' },
            left: { style: 'thin' },
            bottom: { style: 'thin' },
            right: { style: 'thin' } 
        };
      });

      // 5. Add Data Rows
      let grandAmount = 0;

      _data.forEach(record => {
        // Add a row for the Vendor Name
        const vendorHeaderRow = worksheet.addRow([record.vendorName]);
        vendorHeaderRow.font = { bold: true };
        vendorHeaderRow.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'F2F2F2' } };
        
        // Merge vendor name across cells A-C
        worksheet.mergeCells(`A${vendorHeaderRow.number}:C${vendorHeaderRow.number}`);

        record.orders.forEach(order => {
          order.items.forEach(itemRow => {
            const row = worksheet.addRow([
              FormatDateToMDY(order.date),
              order.referenceNumber?.toString(),
              "",
              record.terms || "",
              parseFloat(itemRow.totalAmount || 0),
            ]);

            // Apply Number Formatting to Amount
            row.getCell(4).numFmt = '#,##0.00';
          });
        });

        // 6. Add Vendor Sub-Total Row
        const subTotalRow = worksheet.addRow([
          `Supplier Sub-Total:`, '', '', '',
          parseFloat(record.totalAmount || 0)
        ]);
        
        subTotalRow.font = { bold: true, italic: true };
        subTotalRow.getCell(5).numFmt = '#,##0.00';
        subTotalRow.getCell(5).border = { 
            top: { style: 'thin' },
            bottom: { style: 'thin' } 
        };
        
        grandAmount += parseFloat(record.totalAmount || 0);
        worksheet.addRow([]); // Blank line after each vendor
      });

      // 7. Add Grand Totals Footer
      const grandTotalRow = worksheet.addRow([
        'GRAND TOTAL', '', '', '',
        grandAmount
      ]);

      grandTotalRow.font = { bold: true, size: 12 };
      grandTotalRow.getCell(5).numFmt = '#,##0.00';
      grandTotalRow.getCell(5).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFF00' } }; // Yellow highlight
      grandTotalRow.getCell(5).border = { 
        top: { style: 'thin' }, 
        bottom: { style: 'double' } 
      };

      // 8. Adjust Column Widths
      worksheet.columns = [
        { width: 15 }, // Date
        { width: 25 }, // Doc No
        { width: 25 }, // Doc No
        { width: 25 }, // Terms
        { width: 20 }, // Amount
      ];

      // 9. Generate and Download File
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const filename = `Purchase_Order_Vendor_Summarized_${new Date().getTime()}.xlsx`;
      
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = filename;
      link.click();
      URL.revokeObjectURL(link.href);

    } catch (error) {
      console.error("Excel Error:", error);
      setFailMessage("Error generating Excel file");
    }

    setLoading(false);
  };

  const exportPurchaseOrderByDateDetailedExcel = async () => {
    if (!dateFrom || !dateTo || !company) {
      setFailMessage("Please fill up Date From, Date To, Company fields");
      return;
    }

    setLoading(true);

    try {
      const allData = await fetchReportData();
      const _data = allData?.byDateDetailed;

      if (!_data || _data?.length <= 0) {
        setFailMessage("No record found");
        setLoading(false);
        return;
      }

      // 1. Create Workbook and Worksheet
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('PO Detailed by Date');

      // 2. Add Company Header Information
      worksheet.addRow([company.name?.toUpperCase()]).font = { bold: true, size: 14 };
      worksheet.addRow([company.address]);
      worksheet.addRow([`TIN: ${company.tin}`]);
      worksheet.addRow([]); // Gap

      // 3. Add Report Specific Info
      worksheet.addRow(['PURCHASE ORDER BY DATE (DETAILED)']).font = { bold: true };
      worksheet.addRow([`Period: ${FormatDateToWord(dateFrom)} to ${FormatDateToWord(dateTo)}`]);
      worksheet.addRow([`Date Printed: ${FormatDateToWord(new Date())}`]);
      worksheet.addRow([]); // Gap

      // 4. Define Table Columns
      const headerRow = worksheet.addRow([
        'Item',
        'Qty',
        'UOM',
        'Unit Price',
        'Discount',
        'Net Price',
        'Gross Vatable',
        'Vatable',
        'VAT',
        'Total Amount'
      ]);

      // Style the Header Row
      headerRow.eachCell((cell) => {
        cell.font = { bold: true, color: { argb: 'FFFFFF' } };
        cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '444444' } };
        cell.alignment = { vertical: 'middle', horizontal: 'center' };
        cell.border = { bottom: { style: 'thin' }, right: { style: 'thin' } };
      });

      // 5. Initialize Grand Totals
      let grandGrossVatable = 0;
      let grandVatable = 0;
      let grandVatAmount = 0;
      let grandAmount = 0;

      // 6. Loop through Data
      _data.forEach(record => {
        // Add a PO Info row (Date, Ref No, Vendor)
        const poHeaderRow = worksheet.addRow([
          `Date: ${FormatDateToMDY(record.date)} | Ref: ${record.referenceNumber ?? ""} | Vendor: ${record.vendorName1 ?? ""}`
        ]);
        poHeaderRow.font = { bold: true };
        poHeaderRow.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'F2F2F2' } };
        worksheet.mergeCells(`A${poHeaderRow.number}:J${poHeaderRow.number}`);

        let subGrossVatable = 0;
        let subVatable = 0;
        let subVatAmount = 0;
        let subAmount = 0;

        record.items.forEach(itemRow => {
          const row = worksheet.addRow([
            itemRow.itemDescription,
            parseFloat(itemRow.quantity || 0),
            itemRow.uomName,
            parseFloat(itemRow.unitPrice || 0),
            parseFloat(itemRow.totalDiscount || 0),
            parseFloat(itemRow.netPrice || 0),
            parseFloat(itemRow.vaTableSales || 0), // Gross Vatable
            parseFloat(itemRow.vaTableSales || 0), // Vatable
            parseFloat(itemRow.vat || 0),
            parseFloat(itemRow.totalAmount || 0),
          ]);

          // Apply Number Formatting
          const numericCols = [2, 4, 5, 6, 7, 8, 9, 10];
          numericCols.forEach(col => {
            row.getCell(col).numFmt = '#,##0.00';
          });

          // Accumulate Sub Totals
          subGrossVatable += parseFloat(itemRow.vaTableSales || 0);
          subVatable += parseFloat(itemRow.vaTableSales || 0);
          subVatAmount += parseFloat(itemRow.vat || 0);
          subAmount += parseFloat(itemRow.totalAmount || 0);
        });

        // Add Sub-Total Row for this PO
        const subTotalRow = worksheet.addRow([
          'Sub Total:', '', '', '', '', '',
          subGrossVatable,
          subVatable,
          subVatAmount,
          subAmount
        ]);
        
        subTotalRow.font = { bold: true };
        const subTotalNumericCols = [7, 8, 9, 10];
        subTotalNumericCols.forEach(col => {
            subTotalRow.getCell(col).numFmt = '#,##0.00';
            subTotalRow.getCell(col).border = { top: { style: 'thin' } };
        });

        // Accumulate Grand Totals
        grandGrossVatable += subGrossVatable;
        grandVatable += subVatable;
        grandVatAmount += subVatAmount;
        grandAmount += subAmount;

        worksheet.addRow([]); // Blank line after each record section
      });

      // 7. Add Grand Totals Footer
      const grandTotalRow = worksheet.addRow([
        'GRAND TOTAL', '', '', '', '', '',
        grandGrossVatable,
        grandVatable,
        grandVatAmount,
        grandAmount
      ]);

      grandTotalRow.font = { bold: true, size: 11 };
      const grandTotalNumericCols = [7, 8, 9, 10];
      grandTotalNumericCols.forEach(col => {
          grandTotalRow.getCell(col).numFmt = '#,##0.00';
          grandTotalRow.getCell(col).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFF00' } };
          grandTotalRow.getCell(col).border = { top: { style: 'thin' }, bottom: { style: 'double' } };
      });

      // 8. Adjust Column Widths
      worksheet.columns = [
        { width: 40 }, // Item Description
        { width: 10 }, // Qty
        { width: 10 }, // UOM
        { width: 15 }, // Unit Price
        { width: 15 }, // Discount
        { width: 15 }, // Net Price
        { width: 15 }, // Gross Vatable
        { width: 15 }, // Vatable
        { width: 12 }, // VAT
        { width: 18 }, // Total Amount
      ];

      // 9. Generate and Download File
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const filename = `PO_Date_Detailed_${new Date().getTime()}.xlsx`;
      
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = filename;
      link.click();
      URL.revokeObjectURL(link.href);

    } catch (error) {
      console.error("Excel Error:", error);
      setFailMessage("Error generating Excel file");
    }

    setLoading(false);
  };

  const exportPurchaseOrderByDateSummarizedExcel = async () => {
    if (!dateFrom || !dateTo || !company) {
      setFailMessage("Please fill up Date From, Date To, Company fields");
      return;
    }

    setLoading(true);

    try {
      const allData = await fetchReportData();
      const _data = allData?.byDateDetailed;

      if (!_data || _data?.length <= 0) {
        setFailMessage("No record found");
        setLoading(false);
        return;
      }

      // 1. Create Workbook and Worksheet
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('PO Summarized by Date');

      // 2. Add Company Header Information
      worksheet.addRow([company.name?.toUpperCase()]).font = { bold: true, size: 14 };
      worksheet.addRow([company.address]);
      worksheet.addRow([`TIN: ${company.tin}`]);
      worksheet.addRow([]); // Gap

      // 3. Add Report Specific Info
      worksheet.addRow(['PURCHASE ORDER BY DATE (SUMMARIZED)']).font = { bold: true };
      worksheet.addRow([`Period: ${FormatDateToWord(dateFrom)} to ${FormatDateToWord(dateTo)}`]);
      worksheet.addRow([`Date Printed: ${FormatDateToWord(new Date())}`]);
      worksheet.addRow([]); // Gap

      // 4. Define Table Columns
      const headerRow = worksheet.addRow([
        'Date',
        'Doc. No.',
        'Supplier',
        'Terms',
        'Gross',
        'Discount',
        'Gross Vatable',
        'Vatable',
        'VAT',
        'Amount'
      ]);

      // Style the Header Row
      headerRow.eachCell((cell) => {
        cell.font = { bold: true, color: { argb: 'FFFFFF' } };
        cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '444444' } };
        cell.alignment = { vertical: 'middle', horizontal: 'center' };
        cell.border = { bottom: { style: 'thin' }, right: { style: 'thin' } };
      });

      // 5. Initialize Grand Totals
      let grandGross = 0;
      let grandDiscount = 0;
      let grandGrossVatable = 0;
      let grandVatable = 0;
      let grandVatAmount = 0;
      let grandAmount = 0;

      // 6. Loop through Data (Matching your PDF double-loop logic)
      _data.forEach(record => {
        record.items.forEach(itemRow => {
          const row = worksheet.addRow([
            FormatDateToMDY(record.date),
            record.referenceNumber?.toString(),
            record.vendorName1 ?? "",
            record.terms ?? "",
            parseFloat(itemRow.unitPrice || 0),
            parseFloat(itemRow.totalDiscount || 0),
            parseFloat(itemRow.vaTableSales || 0),
            parseFloat(itemRow.vaTableSales || 0),
            parseFloat(itemRow.vat || 0),
            parseFloat(itemRow.totalAmount || 0),
          ]);

          // Apply Number Formatting
          const numericCols = [5, 6, 7, 8, 9, 10];
          numericCols.forEach(col => {
            row.getCell(col).numFmt = '#,##0.00';
          });

          // Accumulate Grand Totals
          grandGross += (itemRow.unitPrice || 0);
          grandDiscount += (itemRow.totalDiscount || 0);
          grandGrossVatable += (itemRow.vaTableSales || 0);
          grandVatable += (itemRow.vaTableSales || 0);
          grandVatAmount += (itemRow.vat || 0);
          grandAmount += (itemRow.totalAmount || 0);
        });
      });

      // 7. Add Grand Totals Footer
      const grandTotalRow = worksheet.addRow([
        'GRAND TOTAL', '', '', '',
        grandGross,
        grandDiscount,
        grandGrossVatable,
        grandVatable,
        grandVatAmount,
        grandAmount
      ]);

      grandTotalRow.font = { bold: true, size: 11 };
      const totalNumericCols = [5, 6, 7, 8, 9, 10];
      totalNumericCols.forEach(col => {
          grandTotalRow.getCell(col).numFmt = '#,##0.00';
          grandTotalRow.getCell(col).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFF00' } };
          grandTotalRow.getCell(col).border = { 
            top: { style: 'thin' }, 
            bottom: { style: 'double' } 
          };
      });

      // 8. Adjust Column Widths
      worksheet.columns = [
        { width: 12 }, // Date
        { width: 15 }, // Doc No
        { width: 30 }, // Vendor
        { width: 15 }, // Terms
        { width: 15 }, // Gross
        { width: 15 }, // Discount
        { width: 15 }, // Gross Vatable
        { width: 15 }, // Vatable
        { width: 12 }, // VAT
        { width: 18 }, // Total Amount
      ];

      // 9. Generate and Download File
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const filename = `PO_Date_Summarized_${new Date().getTime()}.xlsx`;
      
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = filename;
      link.click();
      URL.revokeObjectURL(link.href);

    } catch (error) {
      console.error("Excel Error:", error);
      setFailMessage("Error generating Excel file");
    }

    setLoading(false);
  };

  const exportPurchaseOrderByDocNoDetailedExcel = async () => {
    if (!dateFrom || !dateTo || !company) {
      setFailMessage("Please fill up Date From, Date To, Company fields");
      return;
    }

    setLoading(true);

    try {
      const allData = await fetchReportData();
      const _data = allData?.byDateDetailed;

      if (!_data || _data?.length <= 0) {
        setFailMessage("No record found");
        setLoading(false);
        return;
      }

      // 1. Create Workbook and Worksheet
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('PO Detailed by Doc No');

      // 2. Add Company Header Information
      worksheet.addRow([company.name?.toUpperCase()]).font = { bold: true, size: 14 };
      worksheet.addRow([company.address]);
      worksheet.addRow([`TIN: ${company.tin}`]);
      worksheet.addRow([]); // Gap

      // 3. Add Report Specific Info
      worksheet.addRow(['PURCHASE ORDER BY DOC NO (DETAILED)']).font = { bold: true };
      worksheet.addRow([`Period: ${FormatDateToWord(dateFrom)} to ${FormatDateToWord(dateTo)}`]);
      worksheet.addRow([`Date Printed: ${FormatDateToWord(new Date())}`]);
      worksheet.addRow([]); // Gap

      // 4. Define Table Columns
      const headerRow = worksheet.addRow([
        'Item',
        'Qty',
        'UOM',
        'Gross Price',
        'Disc %',
        'Disc. Amt.',
        'Net Price',
        'Amount'
      ]);

      // Style the Header Row
      headerRow.eachCell((cell) => {
        cell.font = { bold: true, color: { argb: 'FFFFFF' } };
        cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '444444' } };
        cell.alignment = { vertical: 'middle', horizontal: 'center' };
        cell.border = { bottom: { style: 'thin' }, right: { style: 'thin' } };
      });

      // 5. Add Data Rows
      let grandAmount = 0;

      _data.forEach(record => {
        // Add a Document Header Row (Doc No, Date, Vendor)
        const docHeaderRow = worksheet.addRow([
          `Doc No: ${record.referenceNumber ?? ""} | Date: ${FormatDateToMDY(record.date)} | Vendor: ${record.vendorName1 ?? ""}`
        ]);
        docHeaderRow.font = { bold: true };
        docHeaderRow.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'F2F2F2' } };
        worksheet.mergeCells(`A${docHeaderRow.number}:H${docHeaderRow.number}`);

        let subAmount = 0;

        record.items.forEach(itemRow => {
          const row = worksheet.addRow([
            itemRow.itemDescription,
            parseFloat(itemRow.quantity || 0),
            itemRow.uomName,
            parseFloat(itemRow.unitPrice || 0),
            parseFloat(itemRow.discountPercent || 0) / 100, // Excel handles % as decimals (0.10 for 10%)
            parseFloat(itemRow.totalDiscount || 0),
            parseFloat(itemRow.netPrice || 0),
            parseFloat(itemRow.totalAmount || 0),
          ]);

          // Apply Number Formatting
          row.getCell(2).numFmt = '#,##0.00'; // Qty
          row.getCell(4).numFmt = '#,##0.00'; // Unit Price
          row.getCell(5).numFmt = '0.00%';    // Disc %
          row.getCell(6).numFmt = '#,##0.00'; // Total Discount
          row.getCell(7).numFmt = '#,##0.00'; // Net Price
          row.getCell(8).numFmt = '#,##0.00'; // Total Amount

          subAmount += parseFloat(itemRow.totalAmount || 0);
        });

        // 6. Add Sub-Total Row for this Document
        const subTotalRow = worksheet.addRow([
          `Sub Total:`, '', '', '', '', '', '',
          subAmount
        ]);
        
        subTotalRow.font = { bold: true };
        subTotalRow.getCell(8).numFmt = '#,##0.00';
        subTotalRow.getCell(8).border = { top: { style: 'thin' } };
        
        grandAmount += subAmount;
        worksheet.addRow([]); // Blank line after each document section
      });

      // 7. Add Grand Totals Footer
      const grandTotalRow = worksheet.addRow([
        'GRAND TOTAL', '', '', '', '', '', '',
        grandAmount
      ]);

      grandTotalRow.font = { bold: true, size: 12 };
      grandTotalRow.getCell(8).numFmt = '#,##0.00';
      grandTotalRow.getCell(8).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFF00' } }; // Yellow highlight
      grandTotalRow.getCell(8).border = { 
        top: { style: 'thin' }, 
        bottom: { style: 'double' } 
      };

      // 8. Adjust Column Widths
      worksheet.columns = [
        { width: 40 }, // Item Description
        { width: 10 }, // Qty
        { width: 10 }, // UOM
        { width: 15 }, // Unit Price
        { width: 10 }, // Disc %
        { width: 15 }, // Total Discount
        { width: 15 }, // Net Price
        { width: 18 }, // Total Amount
      ];

      // 9. Generate and Download File
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const filename = `PO_DocNo_Detailed_${new Date().getTime()}.xlsx`;
      
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = filename;
      link.click();
      URL.revokeObjectURL(link.href);

    } catch (error) {
      console.error("Excel Error:", error);
      setFailMessage("Error generating Excel file");
    }

    setLoading(false);
  };

  const exportPurchaseOrderByDocNoSummarizedExcel = async () => {
    if (!dateFrom || !dateTo || !company) {
      setFailMessage("Please fill up Date From, Date To, Company fields");
      return;
    }

    setLoading(true);

    try {
      const allData = await fetchReportData();
      const _data = allData?.byDateDetailed; // Consistent with your PDF data source

      if (!_data || _data?.length <= 0) {
        setFailMessage("No record found");
        setLoading(false);
        return;
      }

      // 1. Create Workbook and Worksheet
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('PO Summarized by Doc No');

      // 2. Add Company Header Information
      worksheet.addRow([company.name?.toUpperCase()]).font = { bold: true, size: 14 };
      worksheet.addRow([company.address]);
      worksheet.addRow([`TIN: ${company.tin}`]);
      worksheet.addRow([]); // Gap

      // 3. Add Report Specific Info
      worksheet.addRow(['PURCHASE ORDER BY DOC NO (SUMMARIZED)']).font = { bold: true };
      worksheet.addRow([`Period: ${FormatDateToWord(dateFrom)} to ${FormatDateToWord(dateTo)}`]);
      worksheet.addRow([`Date Printed: ${FormatDateToWord(new Date())}`]);
      worksheet.addRow([]); // Gap

      // 4. Define Table Columns
      const headerRow = worksheet.addRow([
        'Doc. No.',
        'Date',
        'Ref. No.',
        'Supplier',
        'Terms',
        'Amount'
      ]);

      // Style the Header Row
      headerRow.eachCell((cell) => {
        cell.font = { bold: true, color: { argb: 'FFFFFF' } };
        cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '444444' } };
        cell.alignment = { vertical: 'middle', horizontal: 'center' };
        cell.border = { 
            top: { style: 'thin' },
            left: { style: 'thin' },
            bottom: { style: 'thin' },
            right: { style: 'thin' } 
        };
      });

      // 5. Add Data Rows
      let grandAmount = 0;

      _data.forEach(record => {
        // In the PDF, a row is drawn for each itemRow within the record
        record.items.forEach(itemRow => {
          const row = worksheet.addRow([
            record.referenceNumber ?? "",
            FormatDateToMDY(record.date),
            "",
            record.vendorName1 ?? "",
            record.terms ?? "",
            parseFloat(itemRow.totalAmount || 0),
          ]);

          // Apply Number Formatting
          row.getCell(6).numFmt = '#,##0.00';

          // Accumulate Grand Total
          grandAmount += (itemRow.totalAmount || 0);
        });
      });

      // 6. Add Grand Totals Footer
      const grandTotalRow = worksheet.addRow([
        'GRAND TOTAL', '', '', '', '',
        grandAmount
      ]);

      grandTotalRow.font = { bold: true, size: 12 };
      grandTotalRow.getCell(6).numFmt = '#,##0.00';
      grandTotalRow.getCell(6).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFF00' } }; // Yellow highlight
      grandTotalRow.getCell(6).border = { 
        top: { style: 'thin' }, 
        bottom: { style: 'double' } 
      };

      // 7. Adjust Column Widths
      worksheet.columns = [
        { width: 20 }, // Doc No
        { width: 15 }, // Date
        { width: 20 }, // Date
        { width: 40 }, // Vendor
        { width: 15 }, // Terms
        { width: 20 }, // Amount
      ];

      // 8. Generate and Download File
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const filename = `PO_DocNo_Summarized_${new Date().getTime()}.xlsx`;
      
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = filename;
      link.click();
      URL.revokeObjectURL(link.href);

    } catch (error) {
      console.error("Excel Error:", error);
      setFailMessage("Error generating Excel file");
    }

    setLoading(false);
  };

  const exportPurchaseOrderByItemDetailedExcel = async () => {
    if (!dateFrom || !dateTo || !company) {
      setFailMessage("Please fill up Date From, Date To, Company fields");
      return;
    }

    setLoading(true);

    try {
      const allData = await fetchReportData();
      const _data = allData?.byItemDetailed;

      if (!_data || _data?.length <= 0) {
        setFailMessage("No record found");
        setLoading(false);
        return;
      }

      // 1. Create Workbook and Worksheet
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('PO Detailed by Item');

      // 2. Add Company Header Information
      worksheet.addRow([company.name?.toUpperCase()]).font = { bold: true, size: 14 };
      worksheet.addRow([company.address]);
      worksheet.addRow([`TIN: ${company.tin}`]);
      worksheet.addRow([]); // Gap

      // 3. Add Report Specific Info
      worksheet.addRow(['PURCHASE ORDER BY ITEM (DETAILED)']).font = { bold: true };
      worksheet.addRow([`Period: ${FormatDateToWord(dateFrom)} to ${FormatDateToWord(dateTo)}`]);
      worksheet.addRow([`Date Printed: ${FormatDateToWord(new Date())}`]);
      worksheet.addRow([]); // Gap

      // 4. Define Table Columns
      const headerRow = worksheet.addRow([
        'Date',
        'Doc. No.',
        'Ref. No.',
        'Supplier',
        'Qty',
        'UOM',
        'Gross Price',
        'Disc %',
        'Disc. Amt.',
        'Net Price',
        'Amount'
      ]);

      // Style the Header Row
      headerRow.eachCell((cell) => {
        cell.font = { bold: true, color: { argb: 'FFFFFF' } };
        cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '444444' } };
        cell.alignment = { vertical: 'middle', horizontal: 'center' };
        cell.border = { 
            top: { style: 'thin' },
            left: { style: 'thin' },
            bottom: { style: 'thin' },
            right: { style: 'thin' } 
        };
      });

      // 5. Add Data Rows
      let grandAmount = 0;

      _data.forEach(record => {
        // Add a row for the Item Description (Header for the section)
        const itemHeaderRow = worksheet.addRow([record.description]);
        itemHeaderRow.font = { bold: true };
        itemHeaderRow.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'F2F2F2' } };
        
        // Merge item description across first few cells
        worksheet.mergeCells(`A${itemHeaderRow.number}:C${itemHeaderRow.number}`);

        record.items.forEach(itemRow => {
          const row = worksheet.addRow([
            FormatDateToMDY(itemRow.date),
            itemRow.docNo?.toString(),
            "",
            itemRow.vendor,
            parseFloat(itemRow.quantity || 0),
            itemRow.uomName,
            parseFloat(itemRow.unitPrice || 0),
            parseFloat(itemRow.discountPercent || 0) / 100, // Excel handles % as decimals
            parseFloat(itemRow.totalDiscount || 0),
            parseFloat(itemRow.netPrice || 0),
            parseFloat(itemRow.totalAmount || 0),
          ]);

          // Apply Number Formatting
          row.getCell(5).numFmt = '#,##0.00'; // Qty
          row.getCell(7).numFmt = '#,##0.00'; // Unit Price
          row.getCell(8).numFmt = '0.00%';    // Disc %
          row.getCell(9).numFmt = '#,##0.00'; // Total Disc
          row.getCell(10).numFmt = '#,##0.00'; // Net Price
          row.getCell(11).numFmt = '#,##0.00'; // Amount
        });

        // 6. Add Item Sub-Total Row
        const subTotalRow = worksheet.addRow([
          `Item Sub-Total:`, '', '', '', '', '', '', '', '', '',
          parseFloat(record.totalAmount || 0)
        ]);
        
        subTotalRow.font = { bold: true, italic: true };
        subTotalRow.getCell(11).numFmt = '#,##0.00';
        subTotalRow.getCell(11).border = { 
            top: { style: 'thin' },
            bottom: { style: 'thin' } 
        };
        
        grandAmount += parseFloat(record.totalAmount || 0);
        worksheet.addRow([]); // Blank line after each item section
      });

      // 7. Add Grand Totals Footer
      const grandTotalRow = worksheet.addRow([
        'GRAND TOTAL', '', '', '', '', '', '', '', '', '',
        grandAmount
      ]);

      grandTotalRow.font = { bold: true, size: 12 };
      grandTotalRow.getCell(11).numFmt = '#,##0.00';
      grandTotalRow.getCell(11).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFF00' } }; // Yellow highlight
      grandTotalRow.getCell(11).border = { 
        top: { style: 'thin' }, 
        bottom: { style: 'double' } 
      };

      // 8. Adjust Column Widths
      worksheet.columns = [
        { width: 12 }, // Date
        { width: 15 }, // Doc No
        { width: 15 }, // Doc No
        { width: 35 }, // Vendor
        { width: 10 }, // Qty
        { width: 10 }, // UOM
        { width: 15 }, // Unit Price
        { width: 10 }, // Disc %
        { width: 15 }, // Total Discount
        { width: 15 }, // Net Price
        { width: 18 }, // Total Amount
      ];

      // 9. Generate and Download File
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const filename = `Purchase_Order_Item_Detailed_${new Date().getTime()}.xlsx`;
      
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = filename;
      link.click();
      URL.revokeObjectURL(link.href);

    } catch (error) {
      console.error("Excel Error:", error);
      setFailMessage("Error generating Excel file");
    }

    setLoading(false);
  };

  const exportPurchaseOrderByItemSummarizedExcel = async () => {
    if (!dateFrom || !dateTo || !company) {
      setFailMessage("Please fill up Date From, Date To, Company fields");
      return;
    }

    setLoading(true);

    try {
      const allData = await fetchReportData();
      const _data = allData?.byItemDetailed; // Data source used in your PDF logic

      if (!_data || _data?.length <= 0) {
        setFailMessage("No record found");
        setLoading(false);
        return;
      }

      // 1. Create Workbook and Worksheet
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('PO Summarized by Item');

      // 2. Add Company Header Information
      worksheet.addRow([company.name?.toUpperCase()]).font = { bold: true, size: 14 };
      worksheet.addRow([company.address]);
      worksheet.addRow([`TIN: ${company.tin}`]);
      worksheet.addRow([]); // Gap

      // 3. Add Report Specific Info
      worksheet.addRow(['PURCHASE ORDER BY ITEM (SUMMARIZED)']).font = { bold: true };
      worksheet.addRow([`Period: ${FormatDateToWord(dateFrom)} to ${FormatDateToWord(dateTo)}`]);
      worksheet.addRow([`Date Printed: ${FormatDateToWord(new Date())}`]);
      worksheet.addRow([]); // Gap

      // 4. Define Table Columns
      const headerRow = worksheet.addRow([
        'Item Description',
        'Quantity',
        'UOM',
        'Total Amount'
      ]);

      // Style the Header Row
      headerRow.eachCell((cell) => {
        cell.font = { bold: true, color: { argb: 'FFFFFF' } };
        cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '444444' } };
        cell.alignment = { vertical: 'middle', horizontal: 'center' };
        cell.border = { 
            top: { style: 'thin' },
            left: { style: 'thin' },
            bottom: { style: 'thin' },
            right: { style: 'thin' } 
        };
      });

      // 5. Add Data Rows
      let grandAmount = 0;

      _data.forEach(record => {
        const row = worksheet.addRow([
          record.description ?? "Unknown Item",
          parseFloat(record.totalQuantity || 0),
          record.uomName ?? "",
          parseFloat(record.totalAmount || 0),
        ]);

        // Apply Number Formatting
        row.getCell(2).numFmt = '#,##0.00'; // Quantity
        row.getCell(4).numFmt = '#,##0.00'; // Total Amount

        grandAmount += parseFloat(record.totalAmount || 0);
      });

      // 6. Add Grand Totals Footer
      const grandTotalRow = worksheet.addRow([
        'GRAND TOTAL', '', '', 
        grandAmount
      ]);

      grandTotalRow.font = { bold: true, size: 12 };
      grandTotalRow.getCell(4).numFmt = '#,##0.00';
      grandTotalRow.getCell(4).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFF00' } }; // Yellow highlight
      grandTotalRow.getCell(4).border = { 
        top: { style: 'thin' }, 
        bottom: { style: 'double' } 
      };

      // 7. Adjust Column Widths
      worksheet.columns = [
        { width: 50 }, // Item Description
        { width: 15 }, // Total Quantity
        { width: 10 }, // UOM
        { width: 20 }, // Total Amount
      ];

      // 8. Generate and Download File
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const filename = `Purchase_Order_Item_Summarized_${new Date().getTime()}.xlsx`;
      
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = filename;
      link.click();
      URL.revokeObjectURL(link.href);

    } catch (error) {
      console.error("Excel Error:", error);
      setFailMessage("Error generating Excel file");
    }

    setLoading(false);
  };

  const exportPurchaseOrderByItemClassificationDetailedExcel = async () => {
    if (!dateFrom || !dateTo || !company) {
      setFailMessage("Please fill up Date From, Date To, Company fields");
      return;
    }

    setLoading(true);

    try {
      const allData = await fetchReportData();
      const categories = allData?.byItemClassificationDetailed || [];

      if (categories.length === 0) {
        setFailMessage("No record found");
        setLoading(false);
        return;
      }

      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('PO by Classification');

      // 1. Company Header
      worksheet.addRow([company.name?.toUpperCase()]).font = { bold: true, size: 14 };
      worksheet.addRow([company.address]);
      worksheet.addRow([`TIN: ${company.tin}`]);
      worksheet.addRow([]); 

      // 2. Report Info
      worksheet.addRow(['Purchase Order Register By Item Classification (Detailed)']).font = { bold: true };
      worksheet.addRow([`Classification: ${categories.map(c => c.categoryName).join(', ')}`]);
      worksheet.addRow([`Period Covered: ${FormatDateToWord(dateFrom)} to ${FormatDateToWord(dateTo)}`]);
      worksheet.addRow([`Date Printed: ${FormatDateToWord(new Date())}`]);
      worksheet.addRow([]); 

      // 3. Define Columns to match image
      // Columns: Date | Doc. No. | Supplier | Quantity | U/M | Net Price | Amount
      const headerRow = worksheet.addRow([
        'Date',
        'Doc. No.',
        'Supplier',
        'Quantity',
        'U/M',
        'Net Price',
        'Amount'
      ]);

      headerRow.eachCell((cell) => {
        cell.font = { bold: true };
        cell.alignment = { vertical: 'middle', horizontal: 'left' };
        cell.border = { 
            top: { style: 'thin' }, 
            bottom: { style: 'thin' }, 
            left: { style: 'thin' }, 
            right: { style: 'thin' } 
        };
      });

      let grandNetAmount = 0;
      let grandAmount = 0;

      // 4. Data Rendering
      categories.forEach(category => {
        // Classification Header (e.g., No Category, Cement)
        const catRow = worksheet.addRow([category.categoryName || "No Category"]);
        catRow.font = { bold: true };
        worksheet.mergeCells(`A${catRow.number}:G${catRow.number}`);

        let categoryNet = 0;
        let categoryAmount = 0;

        category.items.forEach(itemGroup => {
            // Item Description Header (Indented or Bold)
            const itemHeaderRow = worksheet.addRow([itemGroup.itemDescription]);
            itemHeaderRow.font = { bold: false }; // Image shows it's plain text but on its own line
            worksheet.mergeCells(`A${itemHeaderRow.number}:G${itemHeaderRow.number}`);
            
            itemGroup.details.forEach(detail => {
                const row = worksheet.addRow([
                    FormatDateToMDY(detail.date),
                    detail.docNo || "",
                    detail.vendor || "",
                    parseFloat(detail.quantity || 0),
                    detail.uomName || "",
                    parseFloat(detail.netPrice || 0),
                    parseFloat(detail.totalAmount || 0),
                ]);

                // Numeric Formatting
                row.getCell(4).numFmt = '#,##0.00'; // Qty
                row.getCell(6).numFmt = '#,##0.00'; // Net Price
                row.getCell(7).numFmt = '#,##0.00'; // Amount
                
                categoryNet += parseFloat(detail.netPrice || 0);
                categoryAmount += parseFloat(detail.totalAmount || 0);
            });
        });

        // 5. Classification Sub-Total
        const subTotalRow = worksheet.addRow([
          `Item Classification Sub-Total`, '', '', '', '',
          categoryNet,
          categoryAmount
        ]);
        
        subTotalRow.font = { bold: true };
        subTotalRow.getCell(6).numFmt = '#,##0.00';
        subTotalRow.getCell(7).numFmt = '#,##0.00';
        
        // Add the horizontal line seen in the image
        ['F', 'G'].forEach(col => {
            subTotalRow.getCell(col).border = { top: { style: 'thin' } };
        });

        grandNetAmount += categoryNet;
        grandAmount += categoryAmount;
        worksheet.addRow([]); // Gap between categories
      });

      // 6. Grand Total
      const grandTotalRow = worksheet.addRow([
        'GRAND TOTAL', '', '', '', '',
        grandNetAmount,
        grandAmount
      ]);

      grandTotalRow.font = { bold: true, size: 11 };
      grandTotalRow.getCell(6).numFmt = '#,##0.00';
      grandTotalRow.getCell(7).numFmt = '#,##0.00';
      
      // Styling Grand Total lines
      ['F', 'G'].forEach(col => {
          grandTotalRow.getCell(col).border = { 
              top: { style: 'thin' }, 
              bottom: { style: 'double' } 
          };
      });

      // Column Widths
      worksheet.columns = [
        { width: 15 }, // Date
        { width: 20 }, // Doc No
        { width: 45 }, // Supplier
        { width: 12 }, // Qty
        { width: 10 }, // U/M
        { width: 15 }, // Net Price
        { width: 18 }, // Amount
      ];

      // 7. Download
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const filename = `PO_Register_Classification_Detailed_${new Date().getTime()}.xlsx`;
      
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = filename;
      link.click();
      URL.revokeObjectURL(link.href);

    } catch (error) {
      console.error("Excel Error:", error);
      setFailMessage("Error generating Excel file");
    }

    setLoading(false);
  };

  const exportPurchaseOrderByItemClassificationSummarizedExcel = async () => {
    if (!dateFrom || !dateTo || !company) {
      setFailMessage("Please fill up Date From, Date To, Company fields");
      return;
    }

    setLoading(true);

    try {
      const allData = await fetchReportData();
      const categories = allData?.byItemClassificationDetailed || [];

      if (categories.length === 0) {
        setFailMessage("No record found");
        setLoading(false);
        return;
      }

      // 1. Create Workbook and Worksheet
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('PO Classification Summarized');

      // 2. Add Company Header Information
      worksheet.addRow([company.name?.toUpperCase()]).font = { bold: true, size: 14 };
      worksheet.addRow([company.address]);
      worksheet.addRow([`TIN: ${company.tin}`]);
      worksheet.addRow([]); 

      // 3. Add Report Specific Info
      worksheet.addRow(['PURCHASE ORDER REGISTER BY ITEM CLASSIFICATION (SUMMARIZED)']).font = { bold: true };
      worksheet.addRow([`Period Covered: ${FormatDateToWord(dateFrom)} to ${FormatDateToWord(dateTo)}`]);
      worksheet.addRow([`Date Printed: ${FormatDateToWord(new Date())}`]);
      worksheet.addRow([]); 

      // 4. Define Table Columns
      const headerRow = worksheet.addRow([
        'Item Description',
        'Quantity',
        'U/M',
        'Net Price',
        'Amount'
      ]);

      // Style the Header Row
      headerRow.eachCell((cell) => {
        cell.font = { bold: true, color: { argb: 'FFFFFF' } };
        cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '444444' } };
        cell.alignment = { vertical: 'middle', horizontal: 'center' };
        cell.border = { 
            top: { style: 'thin' }, 
            left: { style: 'thin' }, 
            bottom: { style: 'thin' }, 
            right: { style: 'thin' } 
        };
      });

      // 5. Add Data Rows
      let grandNetAmount = 0;
      let grandAmount = 0;

      categories.forEach(category => {
        // Add Category Row (e.g., Mobilization, Cement)
        const catRow = worksheet.addRow([category.categoryName || "No Category"]);
        catRow.font = { bold: true };
        catRow.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'F2F2F2' } };
        worksheet.mergeCells(`A${catRow.number}:E${catRow.number}`);

        let categoryNet = 0;
        let categoryAmount = 0;

        category.items.forEach(itemGroup => {
            itemGroup.details.forEach(detail => {
                const row = worksheet.addRow([
                    itemGroup.itemDescription || "",
                    parseFloat(detail.quantity || 0),
                    detail.uomName || "",
                    parseFloat(detail.netPrice || 0),
                    parseFloat(detail.totalAmount || 0),
                ]);

                // Apply Number Formatting
                row.getCell(2).numFmt = '#,##0.00'; // Qty
                row.getCell(4).numFmt = '#,##0.00'; // Net Price
                row.getCell(5).numFmt = '#,##0.00'; // Amount

                categoryNet += parseFloat(detail.netPrice || 0);
                categoryAmount += parseFloat(detail.totalAmount || 0);
            });
        });

        // 6. Add Classification Sub-Total Row
        const subTotalRow = worksheet.addRow([
          `Item Classification Sub-Total:`, '', '',
          categoryNet,
          categoryAmount
        ]);
        
        subTotalRow.font = { bold: true, italic: true };
        subTotalRow.getCell(4).numFmt = '#,##0.00';
        subTotalRow.getCell(5).numFmt = '#,##0.00';
        subTotalRow.getCell(4).border = { top: { style: 'thin' } };
        subTotalRow.getCell(5).border = { top: { style: 'thin' } };
        
        grandNetAmount += categoryNet;
        grandAmount += categoryAmount;
        
        worksheet.addRow([]); // Blank line after each classification section
      });

      // 7. Add Grand Totals Footer
      const grandTotalRow = worksheet.addRow([
        'GRAND TOTAL', '', '',
        grandNetAmount,
        grandAmount
      ]);

      grandTotalRow.font = { bold: true, size: 12 };
      grandTotalRow.getCell(4).numFmt = '#,##0.00';
      grandTotalRow.getCell(5).numFmt = '#,##0.00';
      grandTotalRow.getCell(4).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFF00' } };
      grandTotalRow.getCell(5).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFF00' } };
      grandTotalRow.getCell(4).border = { top: { style: 'thin' }, bottom: { style: 'double' } };
      grandTotalRow.getCell(5).border = { top: { style: 'thin' }, bottom: { style: 'double' } };

      // 8. Adjust Column Widths
      worksheet.columns = [
        { width: 45 }, // Item Description
        { width: 15 }, // Qty
        { width: 10 }, // UOM
        { width: 18 }, // Net Price
        { width: 20 }, // Amount
      ];

      // 9. Generate and Download File
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const filename = `PO_Classification_Summarized_${new Date().getTime()}.xlsx`;
      
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = filename;
      link.click();
      URL.revokeObjectURL(link.href);

    } catch (error) {
      console.error("Excel Error:", error);
      setFailMessage("Error generating Excel file");
    }

    setLoading(false);
  };

  const exportPurchaseOrderByItemVendorDetailedExcel = async () => {
    if (!dateFrom || !dateTo || !company) {
      setFailMessage("Please fill up Date From, Date To, Company fields");
      return;
    }

    setLoading(true);

    try {
      const allData = await fetchReportData();
      const groupedData = allData?.byItemVendorDetailed || [];

      if (groupedData.length === 0) {
        setFailMessage("No record found");
        setLoading(false);
        return;
      }

      // 1. Create Workbook and Worksheet
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('PO by Item-Vendor');

      // 2. Add Company Header Information
      worksheet.addRow([company.name?.toUpperCase()]).font = { bold: true, size: 14 };
      worksheet.addRow([company.address]);
      worksheet.addRow([`TIN: ${company.tin}`]);
      worksheet.addRow([]); // Gap

      // 3. Add Report Specific Info
      worksheet.addRow(['PURCHASE ORDER REGISTER BY ITEM & VENDOR (DETAILED)']).font = { bold: true };
      worksheet.addRow([`Period: ${FormatDateToWord(dateFrom)} to ${FormatDateToWord(dateTo)}`]);
      worksheet.addRow([`Date Printed: ${FormatDateToWord(new Date())}`]);
      worksheet.addRow([]); // Gap

      // 4. Define Table Columns
      const headerRow = worksheet.addRow([
        'Supplier',
        'Date',
        'Doc. No.',
        'Quantity',
        'UOM',
        'VATable',
        'VAT Amount',
        'Total Amount'
      ]);

      // Style the Header Row
      headerRow.eachCell((cell) => {
        cell.font = { bold: true, color: { argb: 'FFFFFF' } };
        cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '444444' } };
        cell.alignment = { vertical: 'middle', horizontal: 'center' };
        cell.border = { top: { style: 'thin' }, bottom: { style: 'thin' } };
      });

      // 5. Main Data Loops
      let grandTotalAmount = 0;

      groupedData.forEach(itemGroup => {
        // --- ITEM HEADER ---
        const itemRow = worksheet.addRow([itemGroup.itemDescription || "Unknown Item"]);
        itemRow.font = { bold: true };
        itemRow.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'E0E0E0' } }; // Light grey
        worksheet.mergeCells(`A${itemRow.number}:H${itemRow.number}`);

        itemGroup.vendors.forEach(vendor => {
          // --- VENDOR SUB-HEADER ---
          const vendorRow = worksheet.addRow([`   ${vendor.vendorName}`]); // Indented for visual hierarchy
          vendorRow.font = { bold: true, italic: true };
          worksheet.mergeCells(`A${vendorRow.number}:H${vendorRow.number}`);

          vendor.transactions.forEach(detail => {
            const row = worksheet.addRow([
              "", // Column 1 empty to maintain hierarchy
              FormatDateToMDY(detail.date),
              detail.docNo || "",
              parseFloat(detail.quantity || 0),
              detail.uomName || "",
              parseFloat(detail.vatable || 0),
              parseFloat(detail.vatAmount || 0),
              parseFloat(detail.totalAmount || 0),
            ]);

            // Formatting
            const numCols = [4, 6, 7, 8];
            numCols.forEach(col => {
              row.getCell(col).numFmt = '#,##0.00';
            });
          });

          // --- VENDOR SUB-TOTAL ---
          const vSubRow = worksheet.addRow([
            `     `, '', '', '', '', '', '',
            parseFloat(vendor.vendorSubTotal || 0)
          ]);
          vSubRow.font = { italic: true, size: 9 };
          vSubRow.getCell(8).numFmt = '#,##0.00';
          vSubRow.getCell(8).border = { top: { style: 'thin' } };
        });

        // --- ITEM SUB-TOTAL SECTION ---
        const itemSubRow = worksheet.addRow([
          `Item Sub-Total :`, '', '', '', '', '', '',
          parseFloat(itemGroup.itemSubTotal || 0)
        ]);
        itemSubRow.font = { bold: true };
        itemSubRow.getCell(8).numFmt = '#,##0.00';
        itemSubRow.getCell(8).border = { 
            top: { style: 'thin' }, 
            bottom: { style: 'double' } 
        };

        grandTotalAmount += parseFloat(itemGroup.itemSubTotal || 0);
        worksheet.addRow([]); // Gap between Item Groups
      });

      // 6. Grand Total Footer
      const grandTotalRow = worksheet.addRow([
        'GRAND TOTAL', '', '', '', '', '', '',
        grandTotalAmount
      ]);

      grandTotalRow.font = { bold: true, size: 12 };
      grandTotalRow.getCell(8).numFmt = '#,##0.00';
      grandTotalRow.getCell(8).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFF00' } }; // Yellow highlight
      grandTotalRow.getCell(8).border = { 
        top: { style: 'thin' }, 
        bottom: { style: 'double' } 
      };

      // 7. Adjust Column Widths
      worksheet.columns = [
        { width: 35 }, // Description / Vendor
        { width: 12 }, // Date
        { width: 15 }, // Doc No
        { width: 12 }, // Qty
        { width: 10 }, // UOM
        { width: 15 }, // Vatable
        { width: 15 }, // Vat Amount
        { width: 18 }, // Total Amount
      ];

      // 8. Generate and Download
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const filename = `PO_Item_Vendor_Detailed_${new Date().getTime()}.xlsx`;
      
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = filename;
      link.click();
      URL.revokeObjectURL(link.href);

    } catch (error) {
      console.error("Excel Error:", error);
      setFailMessage("Error generating Excel file");
    }

    setLoading(false);
  };

  const exportPurchaseOrderByItemVendorSummarizedExcel = async () => {
    if (!dateFrom || !dateTo || !company) {
      setFailMessage("Please fill up Date From, Date To, Company fields");
      return;
    }

    setLoading(true);

    try {
      const allData = await fetchReportData();
      // Using the nested structure: Items -> Vendors -> Transactions
      const groupedData = allData?.byItemVendorDetailed || [];

      if (groupedData.length === 0) {
        setFailMessage("No record found");
        setLoading(false);
        return;
      }

      // 1. Create Workbook and Worksheet
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('PO Item-Vendor Summarized');

      // 2. Add Company Header Information
      worksheet.addRow([company.name?.toUpperCase()]).font = { bold: true, size: 14 };
      worksheet.addRow([company.address]);
      worksheet.addRow([`TIN: ${company.tin}`]);
      worksheet.addRow([]); 

      // 3. Add Report Specific Info
      worksheet.addRow(['PURCHASE ORDER BY ITEM & VENDOR (SUMMARIZED)']).font = { bold: true };
      worksheet.addRow([`Period: ${FormatDateToWord(dateFrom)} to ${FormatDateToWord(dateTo)}`]);
      worksheet.addRow([`Date Printed: ${FormatDateToWord(new Date())}`]);
      worksheet.addRow([]); 

      // 4. Define Table Columns
      const headerRow = worksheet.addRow([
        'Supplier',
        'Amount'
      ]);

      // Style the Header Row
      headerRow.eachCell((cell) => {
        cell.font = { bold: true, color: { argb: 'FFFFFF' } };
        cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '444444' } };
        cell.alignment = { vertical: 'middle', horizontal: 'center' };
        cell.border = { bottom: { style: 'thin' }, right: { style: 'thin' } };
      });

      // 5. Add Data Rows
      let grandTotalAmount = 0;

      groupedData.forEach(itemGroup => {
        // --- ITEM HEADER ROW ---
        const itemRow = worksheet.addRow([itemGroup.itemDescription || "Unknown Item"]);
        itemRow.font = { bold: true };
        itemRow.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'F2F2F2' } };
        worksheet.mergeCells(`A${itemRow.number}:B${itemRow.number}`);

        itemGroup.vendors.forEach(vendor => {
          // --- VENDOR SUMMARIZED ROW ---
          // Summarized means we show the Vendor and their total for this item
          const row = worksheet.addRow([
            `   ${vendor.vendorName}`, // Indent vendor name
            parseFloat(vendor.vendorSubTotal || 0)
          ]);

          // Apply Number Formatting
          row.getCell(2).numFmt = '#,##0.00';
        });

        // --- ITEM SUB-TOTAL ROW ---
        const subTotalRow = worksheet.addRow([
          `Item Sub-Total :`,
          parseFloat(itemGroup.itemSubTotal || 0)
        ]);
        
        subTotalRow.font = { bold: true, italic: true };
        subTotalRow.getCell(2).numFmt = '#,##0.00';
        subTotalRow.getCell(2).border = { 
            top: { style: 'thin' },
            bottom: { style: 'thin' } 
        };
        
        grandTotalAmount += parseFloat(itemGroup.itemSubTotal || 0);
        worksheet.addRow([]); // Blank line after each item group
      });

      // 6. Add Grand Totals Footer
      const grandTotalRow = worksheet.addRow([
        'GRAND TOTAL',
        grandTotalAmount
      ]);

      grandTotalRow.font = { bold: true, size: 12 };
      grandTotalRow.getCell(2).numFmt = '#,##0.00';
      grandTotalRow.getCell(2).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFF00' } }; // Yellow highlight
      grandTotalRow.getCell(2).border = { 
        top: { style: 'thin' }, 
        bottom: { style: 'double' } 
      };

      // 7. Adjust Column Widths
      worksheet.columns = [
        { width: 50 }, // Item / Vendor
        { width: 25 }, // Amount
      ];

      // 8. Generate and Download File
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const filename = `PO_Item_Vendor_Summarized_${new Date().getTime()}.xlsx`;
      
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = filename;
      link.click();
      URL.revokeObjectURL(link.href);

    } catch (error) {
      console.error("Excel Error:", error);
      setFailMessage("Error generating Excel file");
    }

    setLoading(false);
  };

//#endregion






//#region Access Template
  const accountData = JSON.parse(localStorage.getItem("accountData"));
  
  if (!accountData?.accessTemplate?.hasPurchaseOrderReport) {
    return <NoAccess />;
  }
//#endregion






//#region UI
  return (
    <>
      <div className="p-6 bg-gray-50 min-h-screen">
        {/* Header Section */}
        <div className="flex flex-col md:flex-row md:items-center justify-between mb-8 gap-4">
          <div>
            <h2 className="text-3xl font-bold text-gray-800 flex items-center gap-2">
              <HistoryEduIcon fontSize="large" className="text-theme-color" />
              {`Purchase Order Report`}
            </h2>
            <p className="text-gray-500 mt-1">Report of all Purchase Orders.</p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="max-w-2xl">
            <label className="block text-sm font-medium mb-1 text-gray-700 ">
              Company <span className="text-red-500">*</span>
            </label>
            <CompanySelect data={company} setData={setCompany} isEditable={true}/>
          </div>
          
          <div className="max-w-2xl">
            <label className="block text-sm font-semibold mb-1 text-gray-700">
              Vendor 
            </label>
            <div className="flex flex-row items-center">
              <input
                type="text"
                placeholder="Select Vendor"
                className="w-full border border-gray-300 text-sm rounded-l-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color focus:border-theme-color transition"
                value={`${vendor ? `${vendor?.vendorId} - ${vendor?.name1}` : ""}`}
                readOnly
              />
              {!vendor ?
                <button className="bg-theme-color hover:bg-theme-color-h p-[5px] rounded-r-lg" onClick={openVendorSelect}>
                  <PersonSearchIcon className="text-white"/>
                </button> 
                :
                <button className="bg-red-400 hover:bg-red-500 p-[5px] rounded-r-lg" onClick={()=>setVendor(null)}>
                  <RemoveCircleIcon className="text-white"/>
                </button>
              }
            </div>
          </div>

          <div className="max-w-2xl">
            <label className="block text-sm font-medium mb-1 text-gray-700 ">
              Date From
            </label>
            <DateSelect data={dateFrom} setData={setDateFrom} isEditable={true}/>
          </div>

          <div className="max-w-2xl">
            <label className="block text-sm font-medium mb-1 text-gray-700 ">
              Date To
            </label>
            <DateSelect data={dateTo} setData={setDateTo} isEditable={true}/>
          </div>
          
          <div className="max-w-2xl">
            <label className="block text-sm font-semibold mb-1 text-gray-700">
              Item 
            </label>
            <div className="flex flex-row items-center">
              <input
                type="text"
                placeholder="Select Item"
                className="w-full border border-gray-300 text-sm rounded-l-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color focus:border-theme-color transition"
                value={`${item ? `${item?.itemCode} - ${item?.itemDescription}` : ""}`}
                readOnly
              />
              {!item ?
                <button className="bg-theme-color hover:bg-theme-color-h p-[5px] rounded-r-lg" onClick={openItemSelect}>
                  <SearchIcon className="text-white"/>
                </button> 
                :
                <button className="bg-red-400 hover:bg-red-500 p-[5px] rounded-r-lg" onClick={()=>setItem(null)}>
                  <RemoveCircleIcon className="text-white"/>
                </button>
              }
            </div>
          </div>

          <div className="max-w-2xl">
            <label className="block text-sm font-medium mb-1 text-gray-700 ">
              Terms
            </label>
            <TermsSelect data={terms} setData={setTerms} isEditable={true}/>
          </div>

          <div className="max-w-2xl">
            <label className="block text-sm font-medium mb-1 text-gray-700 ">
              Document No.
            </label>
            <PurchaseInvoiceOptionalVendorSelect data={invoice} setData={setInvoice} isEditable={true} vendorId={vendor ? vendor?.vendorId : "All"}/>
          </div>

        </div>

        <div className="mt-5 p-6 bg-white rounded-2xl shadow-sm border border-gray-100">
          <h2 className="text-lg font-bold text-gray-800 mb-6 px-2">Generate Purchase Registers</h2>

          {/* Header Row - Hidden on Mobile */}
          <div className="hidden md:grid grid-cols-12 gap-4 px-4 mb-2 text-xs font-black uppercase tracking-widest text-gray-400">
            <div className="col-span-2">Report Category</div>
            <div className="col-span-5">PDF Reports</div>
            <div className="col-span-5 border-l border-gray-100">Excel Reports</div>
          </div>

          <div className="space-y-3">
            {[
              { 
                label: "By Vendor", 
                pdf_detailed: generatePurchaseOrderByVendorDetailedHandleClick, 
                pdf_summarized: generatePurchaseOrderByVendorSummarizedHandleClick,
                excel_detailed: exportPurchaseOrderByVendorDetailedExcel, // Replace with your Excel function
                excel_summarized: exportPurchaseOrderByVendorSummarizedExcel 
              },
              { 
                label: "By Date", 
                pdf_detailed: generatePurchaseOrderByDateDetailedHandleClick, 
                pdf_summarized: generatePurchaseOrderByDateSummarizedHandleClick,
                excel_detailed: exportPurchaseOrderByDateDetailedExcel, 
                excel_summarized: exportPurchaseOrderByDateSummarizedExcel 
              },
              { 
                label: "By Doc No", 
                pdf_detailed: generatePurchaseOrderByDocNoDetailedHandleClick, 
                pdf_summarized: generatePurchaseOrderByDocNoSummarizedHandleClick,
                excel_detailed: exportPurchaseOrderByDocNoDetailedExcel, 
                excel_summarized: exportPurchaseOrderByDocNoSummarizedExcel
              },
              { 
                label: "By Item", 
                pdf_detailed: generatePurchaseOrderByItemDetailedHandleClick, 
                pdf_summarized: generatePurchaseOrderByItemSummarizedHandleClick,
                excel_detailed: exportPurchaseOrderByItemDetailedExcel, 
                excel_summarized: exportPurchaseOrderByItemSummarizedExcel
              },
              { 
                label: "By Item Classification", 
                pdf_detailed: generatePurchaseOrderByItemClassificationDetailedHandleClick, 
                pdf_summarized: generatePurchaseOrderByItemClassificationSummarizedHandleClick,
                excel_detailed: exportPurchaseOrderByItemClassificationDetailedExcel, 
                excel_summarized: exportPurchaseOrderByItemClassificationSummarizedExcel
              },
              { 
                label: "By Item & Supplier", 
                pdf_detailed: generatePurchaseOrderByItemVendorDetailedHandleClick, 
                pdf_summarized: generatePurchaseOrderByItemVendorSummarizedHandleClick,
                excel_detailed: exportPurchaseOrderByItemVendorDetailedExcel, 
                excel_summarized: exportPurchaseOrderByItemVendorSummarizedExcel
              },
            ].map((group, idx) => (
              <div key={idx} className="grid grid-cols-1 md:grid-cols-12 items-center gap-4 p-4 rounded-xl border border-gray-100 hover:bg-gray-50 transition-colors">
                
                {/* Label */}
                <div className="col-span-2">
                  <span className="text-sm font-bold text-gray-700">{group.label}</span>
                </div>

                {/* PDF Column */}
                <div className="col-span-5 flex flex-wrap gap-2">
                  { group.pdf_detailed &&
                    <button 
                      onClick={group.pdf_detailed} 
                      className="flex items-center gap-2 bg-red-50 text-red-700 border border-red-100 px-3 py-1.5 rounded-lg text-xs font-bold hover:bg-red-100 transition-all active:scale-95"
                      title="Download PDF Detailed"
                    >
                      <RestartAltIcon sx={{ fontSize: 16 }} /> Detailed
                    </button>
                  }
                  
                  { group.pdf_summarized &&
                    <button 
                      onClick={group.pdf_summarized} 
                      className="flex items-center gap-2 bg-white text-gray-700 border border-gray-300 px-3 py-1.5 rounded-lg text-xs font-bold hover:bg-gray-50 transition-all active:scale-95"
                    >
                      Summarized
                    </button>
                  }

                  {group.pdf_extra && (
                    <button 
                      onClick={group.pdf_extra} 
                      className="flex items-center gap-2 bg-blue-50 text-blue-700 border border-blue-100 px-3 py-1.5 rounded-lg text-xs font-bold hover:bg-blue-100 transition-all active:scale-95"
                    >
                      Summarized w/ %
                    </button>
                  )}
                </div>

                {/* Excel Column */}
                <div className="col-span-5 flex flex-wrap gap-2 border-t md:border-t-0 md:border-l border-gray-100 pt-3 md:pt-0">
                  { group.excel_detailed &&
                    <button 
                      onClick={group.excel_detailed} 
                      className="flex items-center gap-2 bg-green-600 text-white px-3 py-1.5 rounded-lg text-xs font-bold hover:bg-green-700 shadow-sm transition-all active:scale-95"
                    >
                      Excel Detailed
                    </button>
                  }
                  
                  { group.excel_summarized &&
                    <button 
                      onClick={group.excel_summarized} 
                      className="flex items-center gap-2 bg-green-50 text-green-700 border border-green-200 px-3 py-1.5 rounded-lg text-xs font-bold hover:bg-green-100 transition-all active:scale-95"
                    >
                      Excel Summ.
                    </button>
                  }
                  
                  
                  { group.excel_extra &&
                    <button 
                      onClick={group.excel_extra} 
                      className="flex items-center gap-2 bg-green-50 text-green-700 border border-green-200 px-3 py-1.5 rounded-lg text-xs font-bold hover:bg-green-100 transition-all active:scale-95"
                    >
                      Excel Summ. w/ %
                    </button>
                  }
                </div>

              </div>
            ))}
          </div>
        </div>
      </div>
      
      <VendorSelect 
        visible={showVendorSelect} 
        onClose={closeVendorSelect}
        modalName={"Select Vendor"}
        data={vendor} setData={setVendor}
      />
      
      <ItemsSelect 
        visible={showItemSelect} 
        onClose={closeItemSelect}
        modalName={"Select Item"}
        data={item} setData={setItem}
      />

      <div className="fixed top-5 right-5 z-50 flex flex-col space-y-2">
        <SuccessMessage message={successMessage} onClose={() => setSuccessMessage("")} />
        <FailMessage message={failMessage} onClose={() => setFailMessage("")} />
      </div>

      { loading && <Loading />}
    </>
  );
//#endregion
}